import { EventEmitter, Component, HostBinding, Input, Output, ViewChild, ChangeDetectionStrategy, Renderer2, ChangeDetectorRef, ContentChild, Pipe, NgModule } from '@angular/core';
import { ResponsiveService, HeaderPositioningService, B2CSharedPositionModule, B2CSharedResponsiveModule, SharedDirectiveModule } from 'b2c-ui/core';
import { I18nTransKey, I18nModule } from 'b2c-ui/i18n';
import { Subject, fromEvent } from 'rxjs';
import { tap, filter, debounceTime, takeUntil } from 'rxjs/operators';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { B2CNgzIconModule } from 'b2c-ui/ngz-icons';
import { FsmoneLogoIcon, FsmoneMobileLogoIcon, FundTypeIcon, AboutTypeIcon, EtfsTypeIcon, BondsTypeIcon, DpmsTypeIcon, InsuranceTypeIcon, SupportIcon, MalaysiaIcon, SingaporeIcon, HongKongIcon, IndiaIcon, ResearchArticleIcon, FaqIcon, StocksTypeIcon, FooterLogoIcon, FooterAppstoreIcon, FooterPlaystoreIcon, IconFacebookFillIcon, IconInstagramFillIcon, IconTelegramFillIcon, IconYoutubeFillIcon, IconTwitterFillIcon, B2cUiIconModule, B2CUiIconService } from 'b2c-ui-icon';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { B2CInfiniteScrollModule } from 'b2c-ui/infinite-scroll';
import { B2CMobileSelectModule } from 'b2c-ui/mobile-select';
import { RouterModule } from '@angular/router';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-header.constant.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'b2c-ui/core';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from 'ng-zorro-antd/input';
import * as ɵngcc5 from 'b2c-ui/mobile-select';
import * as ɵngcc6 from 'b2c-ui-icon';
import * as ɵngcc7 from 'ng-zorro-antd/select';
import * as ɵngcc8 from 'b2c-ui/infinite-scroll';
import * as ɵngcc9 from 'ng-zorro-antd/spin';
import * as ɵngcc10 from 'b2c-ui/i18n';
import * as ɵngcc11 from 'ng-zorro-antd';
import * as ɵngcc12 from 'ng-zorro-antd/drawer';
import * as ɵngcc13 from '@angular/router';
import * as ɵngcc14 from 'ng-zorro-antd/grid';

const _c0 = ["typeahead"];
function B2CHeaderSearchComponent_div_1_b2c_mobile_select_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "b2c-mobile-select-option", 10);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 11);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", item_r8);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("name", item_r8 == null ? null : item_r8.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r8 == null ? null : item_r8.label, " ");
} }
function B2CHeaderSearchComponent_div_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const selected_r9 = ctx.selected;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("name", selected_r9 == null ? null : selected_r9.value == null ? null : selected_r9.value.icon);
} }
function B2CHeaderSearchComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "b2c-mobile-select", 7);
    ɵngcc0.ɵɵtemplate(2, B2CHeaderSearchComponent_div_1_b2c_mobile_select_option_2_Template, 4, 3, "b2c-mobile-select-option", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, B2CHeaderSearchComponent_div_1_ng_template_3_Template, 2, 1, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r6 = ɵngcc0.ɵɵreference(4);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("single", true)("selectedTemplate", _r6)("transparent", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.activeProductCataloque);
} }
function B2CHeaderSearchComponent_ng_template_2_nz_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "nz-option", 16);
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r13 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("nzLabel", item_r13 == null ? null : item_r13.label)("nzValue", item_r13);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("name", item_r13 == null ? null : item_r13.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r13 == null ? null : item_r13.label, " ");
} }
function B2CHeaderSearchComponent_ng_template_2_ng_template_3_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const selected_r14 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(selected_r14 == null ? null : selected_r14.nzLabel);
} }
function B2CHeaderSearchComponent_ng_template_2_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "b2c-ui-icon", 11);
    ɵngcc0.ɵɵtemplate(1, B2CHeaderSearchComponent_ng_template_2_ng_template_3_span_1_Template, 2, 1, "span", 17);
} if (rf & 2) {
    const selected_r14 = ctx.$implicit;
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("name", selected_r14 == null ? null : selected_r14.nzValue == null ? null : selected_r14.nzValue.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r12.mobile);
} }
function B2CHeaderSearchComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "nz-select", 13);
    ɵngcc0.ɵɵtemplate(2, B2CHeaderSearchComponent_ng_template_2_nz_option_2_Template, 3, 4, "nz-option", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, B2CHeaderSearchComponent_ng_template_2_ng_template_3_Template, 2, 2, "ng-template", null, 15, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r11 = ɵngcc0.ɵɵreference(4);
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzCustomTemplate", _r11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.activeProductCataloque);
} }
function B2CHeaderSearchComponent_div_8_ng_container_2_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "br");
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r23 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(item_r23 == null ? null : item_r23.subtitle);
} }
function B2CHeaderSearchComponent_div_8_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵlistener("click", function B2CHeaderSearchComponent_div_8_ng_container_2_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r27); const item_r23 = ctx.$implicit; const ctx_r26 = ɵngcc0.ɵɵnextContext(3); return ctx_r26.selectResult(item_r23); });
    ɵngcc0.ɵɵelement(1, "span", 25);
    ɵngcc0.ɵɵpipe(2, "searchHit");
    ɵngcc0.ɵɵtemplate(3, B2CHeaderSearchComponent_div_8_ng_container_2_div_1_ng_container_3_Template, 4, 1, "ng-container", 26);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r23 = ctx.$implicit;
    const ctx_r22 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(2, 2, item_r23 == null ? null : item_r23.label, ctx_r22.queryField), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r23 == null ? null : item_r23.subtitle);
} }
function B2CHeaderSearchComponent_div_8_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CHeaderSearchComponent_div_8_ng_container_2_div_1_Template, 4, 5, "div", 23);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r17.results);
} }
function B2CHeaderSearchComponent_div_8_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵelement(1, "nz-spin", 29);
    ɵngcc0.ɵɵelementStart(2, "span", 30);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 1, ctx_r28.I18nTransKey == null ? null : ctx_r28.I18nTransKey.SEARCHING));
} }
function B2CHeaderSearchComponent_div_8_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, B2CHeaderSearchComponent_div_8_ng_template_3_div_0_Template, 5, 3, "div", 27);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r20 = ɵngcc0.ɵɵreference(6);
    const ctx_r19 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r19.searching)("ngIfElse", _r20);
} }
function B2CHeaderSearchComponent_div_8_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r21.I18nTransKey == null ? null : ctx_r21.I18nTransKey.SEARCH_NO_RESULT), " ");
} }
function B2CHeaderSearchComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "b2c-infinite-scroll", 20);
    ɵngcc0.ɵɵlistener("scrolled", function B2CHeaderSearchComponent_div_8_Template_b2c_infinite_scroll_scrolled_1_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.nextPage.emit(); });
    ɵngcc0.ɵɵtemplate(2, B2CHeaderSearchComponent_div_8_ng_container_2_Template, 2, 1, "ng-container", 1);
    ɵngcc0.ɵɵtemplate(3, B2CHeaderSearchComponent_div_8_ng_template_3_Template, 1, 2, "ng-template", null, 21, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(5, B2CHeaderSearchComponent_div_8_ng_template_5_Template, 3, 3, "ng-template", null, 22, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r18 = ɵngcc0.ɵɵreference(4);
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r4.mobile ? "search-result-mobile" : "search-result-web");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("maxHeight", ctx_r4.mobile ? ctx_r4.height : 400);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r4.results == null ? null : ctx_r4.results.length) && !ctx_r4.searching)("ngIfElse", _r18);
} }
const _c1 = function (a0, a1) { return { "ml-4": a0, "px-3": a1 }; };
const _c2 = ["header"];
const _c3 = ["pusher"];
function B2CWebHeaderComponent_div_0_li_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 25);
    ɵngcc0.ɵɵelementStart(1, "span", 26);
    ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 27);
    ɵngcc0.ɵɵelementStart(3, "a", 28);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const country_r9 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("name", country_r9 == null ? null : country_r9.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", country_r9 == null ? null : country_r9.external, ɵngcc0.ɵɵsanitizeUrl)("title", country_r9 == null ? null : country_r9.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", country_r9 == null ? null : country_r9.title, " ");
} }
function B2CWebHeaderComponent_div_0_ng_container_17_span_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CWebHeaderComponent_div_0_ng_container_17_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 30);
    ɵngcc0.ɵɵtemplate(1, B2CWebHeaderComponent_div_0_ng_container_17_span_1_ng_container_1_Template, 1, 0, "ng-container", 31);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const template_r11 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", template_r11);
} }
function B2CWebHeaderComponent_div_0_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CWebHeaderComponent_div_0_ng_container_17_span_1_Template, 2, 1, "span", 29);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.appBarTemplates);
} }
function B2CWebHeaderComponent_div_0_ul_23_li_1_ng_container_1_ul_9_li_3_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 49);
    ɵngcc0.ɵɵelementStart(1, "a", 50);
    ɵngcc0.ɵɵlistener("click", function B2CWebHeaderComponent_div_0_ul_23_li_1_ng_container_1_ul_9_li_3_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r25); const grandChild_r23 = ctx.$implicit; ɵngcc0.ɵɵnextContext(2); const _r19 = ɵngcc0.ɵɵreference(6); const ctx_r24 = ɵngcc0.ɵɵnextContext(4); return ctx_r24.emitNavigationEvent(grandChild_r23 == null ? null : grandChild_r23.title, grandChild_r23 == null ? null : grandChild_r23.url, _r19); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const grandChild_r23 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(grandChild_r23 == null ? null : grandChild_r23.title);
} }
function B2CWebHeaderComponent_div_0_ul_23_li_1_ng_container_1_ul_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 46);
    ɵngcc0.ɵɵelementStart(1, "li", 47);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, B2CWebHeaderComponent_div_0_ul_23_li_1_ng_container_1_ul_9_li_3_Template, 3, 1, "li", 48);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r21 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(child_r21 == null ? null : child_r21.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", child_r21 == null ? null : child_r21.children);
} }
const _c4 = function (a0) { return { "gridTemplateColumns": a0 }; };
function B2CWebHeaderComponent_div_0_ul_23_li_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 38);
    ɵngcc0.ɵɵlistener("click", function B2CWebHeaderComponent_div_0_ul_23_li_1_ng_container_1_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r28); const _r19 = ɵngcc0.ɵɵreference(6); const _r18 = ɵngcc0.ɵɵreference(4); const item_r14 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r26 = ɵngcc0.ɵɵnextContext(3); return ctx_r26.emitNavigationEvent(item_r14 == null ? null : item_r14.title, item_r14 == null ? null : item_r14.url, _r19, _r18, true); })("mouseout", function B2CWebHeaderComponent_div_0_ul_23_li_1_ng_container_1_Template_a_mouseout_1_listener() { ɵngcc0.ɵɵrestoreView(_r28); const _r19 = ɵngcc0.ɵɵreference(6); const _r18 = ɵngcc0.ɵɵreference(4); const ctx_r29 = ɵngcc0.ɵɵnextContext(4); return ctx_r29.resetMenuState(_r19, _r18); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelement(3, "span", 39, 40);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 41, 42);
    ɵngcc0.ɵɵelementStart(7, "div", 43);
    ɵngcc0.ɵɵelementStart(8, "div", 44);
    ɵngcc0.ɵɵtemplate(9, B2CWebHeaderComponent_div_0_ul_23_li_1_ng_container_1_ul_9_Template, 4, 2, "ul", 45);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r14 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r15 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r14 == null ? null : item_r14.title, " ");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(3, _c4, ctx_r15.calculateGrid(item_r14 == null ? null : item_r14.children)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", item_r14 == null ? null : item_r14.children);
} }
function B2CWebHeaderComponent_div_0_ul_23_li_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 51);
    ɵngcc0.ɵɵlistener("click", function B2CWebHeaderComponent_div_0_ul_23_li_1_ng_template_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r33); const item_r14 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r31 = ɵngcc0.ɵɵnextContext(3); return ctx_r31.emitNavigationEvent(item_r14 == null ? null : item_r14.title, item_r14 == null ? null : item_r14.url); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r14 == null ? null : item_r14.title);
} }
const _c5 = function (a0, a1) { return [a0, a1]; };
function B2CWebHeaderComponent_div_0_ul_23_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 35);
    ɵngcc0.ɵɵtemplate(1, B2CWebHeaderComponent_div_0_ul_23_li_1_ng_container_1_Template, 10, 5, "ng-container", 36);
    ɵngcc0.ɵɵtemplate(2, B2CWebHeaderComponent_div_0_ul_23_li_1_ng_template_2_Template, 2, 1, "ng-template", null, 37, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const _r16 = ɵngcc0.ɵɵreference(3);
    const ctx_r13 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c5, (ctx_r13.structure == null ? null : ctx_r13.structure.length) > 5 ? "ml-1 mr-1" : "ml-2 mr-2", (item_r14 == null ? null : item_r14.children) ? "has-dropdown-menu" : ""));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r14 == null ? null : item_r14.children)("ngIfElse", _r16);
} }
function B2CWebHeaderComponent_div_0_ul_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 32);
    ɵngcc0.ɵɵtemplate(1, B2CWebHeaderComponent_div_0_ul_23_li_1_Template, 4, 6, "li", 33);
    ɵngcc0.ɵɵelement(2, "li", 34);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.structure);
} }
function B2CWebHeaderComponent_div_0_ng_container_24_Template(rf, ctx) { if (rf & 1) {
    const _r36 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementStart(2, "div", 52);
    ɵngcc0.ɵɵlistener("click", function B2CWebHeaderComponent_div_0_ng_container_24_Template_div_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r35 = ɵngcc0.ɵɵnextContext(2); return ctx_r35.toggleSearch(); });
    ɵngcc0.ɵɵelement(3, "i", 53);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function B2CWebHeaderComponent_div_0_div_25_ng_container_3_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CWebHeaderComponent_div_0_div_25_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CWebHeaderComponent_div_0_div_25_ng_container_3_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 31);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const template_r39 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", template_r39);
} }
function B2CWebHeaderComponent_div_0_div_25_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CWebHeaderComponent_div_0_div_25_ng_container_3_ng_container_1_Template, 2, 1, "ng-container", 57);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r37 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r37.actionTemplates);
} }
function B2CWebHeaderComponent_div_0_div_25_Template(rf, ctx) { if (rf & 1) {
    const _r42 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 54);
    ɵngcc0.ɵɵelementStart(1, "span", 55);
    ɵngcc0.ɵɵlistener("click", function B2CWebHeaderComponent_div_0_div_25_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r41 = ɵngcc0.ɵɵnextContext(2); return ctx_r41.toggleSearch(); });
    ɵngcc0.ɵɵelement(2, "i", 56);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, B2CWebHeaderComponent_div_0_div_25_ng_container_3_Template, 2, 1, "ng-container", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.actionTemplates);
} }
const _c6 = function (a0) { return { "top": a0 }; };
function B2CWebHeaderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r44 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3, 4);
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵelementStart(3, "div", 6);
    ɵngcc0.ɵɵelementStart(4, "div", 7);
    ɵngcc0.ɵɵelementStart(5, "span", 8);
    ɵngcc0.ɵɵelementStart(6, "a", 9);
    ɵngcc0.ɵɵelement(7, "i", 10);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelement(9, "i", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 12);
    ɵngcc0.ɵɵelementStart(11, "div", 13);
    ɵngcc0.ɵɵelementStart(12, "h6", 14);
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵpipe(14, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "ul", 15);
    ɵngcc0.ɵɵtemplate(16, B2CWebHeaderComponent_div_0_li_16_Template, 5, 4, "li", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(17, B2CWebHeaderComponent_div_0_ng_container_17_Template, 2, 1, "ng-container", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 18);
    ɵngcc0.ɵɵelementStart(19, "div", 19);
    ɵngcc0.ɵɵelementStart(20, "div", 20);
    ɵngcc0.ɵɵelementStart(21, "div", 21);
    ɵngcc0.ɵɵelementStart(22, "b2c-ui-icon", 22);
    ɵngcc0.ɵɵlistener("click", function B2CWebHeaderComponent_div_0_Template_b2c_ui_icon_click_22_listener() { ɵngcc0.ɵɵrestoreView(_r44); const ctx_r43 = ɵngcc0.ɵɵnextContext(); return ctx_r43.emitNavigationEvent("title", "/"); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(23, B2CWebHeaderComponent_div_0_ul_23_Template, 3, 1, "ul", 23);
    ɵngcc0.ɵɵtemplate(24, B2CWebHeaderComponent_div_0_ng_container_24_Template, 4, 0, "ng-container", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(25, B2CWebHeaderComponent_div_0_div_25_Template, 4, 1, "div", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const posEvent_r2 = ctx.ngIf;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(10, _c6, (posEvent_r2 == null ? null : posEvent_r2.topHeight) + "px"));
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0._country == null ? null : ctx_r0._country.title, " ");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(14, 8, ctx_r0.I18nTransKey == null ? null : ctx_r0.I18nTransKey.SELECT_YOUR_COUNTRY), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0._countries);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.appBarTemplates && ctx_r0.appBarTemplates.length);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.search);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.search);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.search);
} }
const _c7 = ["*"];
function B2CMobileHeaderComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "p", 10);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.pageTitle);
} }
function B2CMobileHeaderComponent_ng_container_7_b2c_ui_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "b2c-ui-icon", 13);
} }
function B2CMobileHeaderComponent_ng_container_7_b2c_ui_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "b2c-ui-icon", 14);
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r16.logoLink);
} }
function B2CMobileHeaderComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CMobileHeaderComponent_ng_container_7_b2c_ui_icon_1_Template, 1, 0, "b2c-ui-icon", 11);
    ɵngcc0.ɵɵtemplate(2, B2CMobileHeaderComponent_ng_container_7_b2c_ui_icon_2_Template, 1, 1, "b2c-ui-icon", 12);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.coerceBoolean(ctx_r1.logoLink));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.coerceBoolean(ctx_r1.logoLink));
} }
function B2CMobileHeaderComponent_i_8_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 15);
    ɵngcc0.ɵɵlistener("click", function B2CMobileHeaderComponent_i_8_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onSearch.emit(); });
    ɵngcc0.ɵɵelementEnd();
} }
function B2CMobileHeaderComponent_ng_container_9_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CMobileHeaderComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵelementStart(2, "div", 17);
    ɵngcc0.ɵɵelementStart(3, "i", 18);
    ɵngcc0.ɵɵlistener("click", function B2CMobileHeaderComponent_ng_container_9_Template_i_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.onSearch.emit(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, B2CMobileHeaderComponent_ng_container_9_ng_container_4_Template, 1, 0, "ng-container", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.notificationTemplate);
} }
function B2CMobileHeaderComponent_div_11_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 26);
    ɵngcc0.ɵɵlistener("click", function B2CMobileHeaderComponent_div_11_ng_container_1_ng_container_2_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r30); const item_r24 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r28 = ɵngcc0.ɵɵnextContext(2); return ctx_r28.setNavContext(item_r24); });
    ɵngcc0.ɵɵelementStart(2, "div", 27);
    ɵngcc0.ɵɵelementStart(3, "span", 32);
    ɵngcc0.ɵɵelement(4, "b2c-ui-icon", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "h5", 28);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "span", 23);
    ɵngcc0.ɵɵelement(8, "i", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r24 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("name", item_r24 == null ? null : item_r24.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r24 == null ? null : item_r24.title);
} }
function B2CMobileHeaderComponent_div_11_ng_container_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 34);
    ɵngcc0.ɵɵlistener("click", function B2CMobileHeaderComponent_div_11_ng_container_1_ng_template_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r34); const item_r24 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ctx_r32.emitEvent(item_r24 == null ? null : item_r24.title, item_r24 == null ? null : item_r24.url, item_r24 == null ? null : item_r24.runOutsideAngular); });
    ɵngcc0.ɵɵelementStart(1, "span", 32);
    ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "h5", 28);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r24 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("name", item_r24 == null ? null : item_r24.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r24 == null ? null : item_r24.title);
} }
function B2CMobileHeaderComponent_div_11_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 29);
    ɵngcc0.ɵɵtemplate(2, B2CMobileHeaderComponent_div_11_ng_container_1_ng_container_2_Template, 9, 2, "ng-container", 30);
    ɵngcc0.ɵɵtemplate(3, B2CMobileHeaderComponent_div_11_ng_container_1_ng_template_3_Template, 5, 2, "ng-template", null, 31, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r24 = ctx.$implicit;
    const _r26 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r24 == null ? null : item_r24.children)("ngIfElse", _r26);
} }
function B2CMobileHeaderComponent_div_11_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CMobileHeaderComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵtemplate(1, B2CMobileHeaderComponent_div_11_ng_container_1_Template, 5, 2, "ng-container", 21);
    ɵngcc0.ɵɵelementStart(2, "div", 22);
    ɵngcc0.ɵɵlistener("click", function B2CMobileHeaderComponent_div_11_Template_div_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r36 = ɵngcc0.ɵɵnextContext(); return ctx_r36.toggleNavCountry(); });
    ɵngcc0.ɵɵtemplate(3, B2CMobileHeaderComponent_div_11_ng_container_3_Template, 1, 0, "ng-container", 19);
    ɵngcc0.ɵɵelementStart(4, "span", 23);
    ɵngcc0.ɵɵelement(5, "i", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 25);
    ɵngcc0.ɵɵelementStart(7, "div", 26);
    ɵngcc0.ɵɵlistener("click", function B2CMobileHeaderComponent_div_11_Template_div_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r38 = ɵngcc0.ɵɵnextContext(); return ctx_r38.setNavContext(ctx_r38.others, true); });
    ɵngcc0.ɵɵelementStart(8, "div", 27);
    ɵngcc0.ɵɵelementStart(9, "h5", 28);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "span", 23);
    ɵngcc0.ɵɵelement(12, "i", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const _r13 = ɵngcc0.ɵɵreference(21);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.structure);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r13);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.others.title);
} }
function B2CMobileHeaderComponent_div_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CMobileHeaderComponent_div_12_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c8 = function (a0) { return { "border-bottom": a0 }; };
function B2CMobileHeaderComponent_div_12_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r47 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 39);
    ɵngcc0.ɵɵlistener("click", function B2CMobileHeaderComponent_div_12_div_2_div_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r47); const child_r44 = ctx.$implicit; const ctx_r46 = ɵngcc0.ɵɵnextContext(3); return ctx_r46.emitEvent(child_r44 == null ? null : child_r44.title, child_r44 == null ? null : child_r44.url, child_r44 == null ? null : child_r44.runOutsideAngular); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r44 = ctx.$implicit;
    const isLast_r45 = ctx.last;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c8, !isLast_r45));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", child_r44 == null ? null : child_r44.title, " ");
} }
const _c9 = function (a0) { return { title: a0 }; };
function B2CMobileHeaderComponent_div_12_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 37);
    ɵngcc0.ɵɵtemplate(1, B2CMobileHeaderComponent_div_12_div_2_ng_container_1_Template, 1, 0, "ng-container", 35);
    ɵngcc0.ɵɵtemplate(2, B2CMobileHeaderComponent_div_12_div_2_div_2_Template, 2, 4, "div", 38);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = ctx.$implicit;
    ɵngcc0.ɵɵnextContext(2);
    const _r11 = ɵngcc0.ɵɵreference(19);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r11)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c9, item_r41 == null ? null : item_r41.title));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", item_r41 == null ? null : item_r41.children);
} }
const _c10 = function (a0, a1) { return { title: a0, fn: a1 }; };
function B2CMobileHeaderComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, B2CMobileHeaderComponent_div_12_ng_container_1_Template, 1, 0, "ng-container", 35);
    ɵngcc0.ɵɵtemplate(2, B2CMobileHeaderComponent_div_12_div_2_Template, 3, 5, "div", 36);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    const _r9 = ɵngcc0.ɵɵreference(17);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(3, _c10, ctx_r5.navContext == null ? null : ctx_r5.navContext.title, ctx_r5.setNavContext));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.navContext == null ? null : ctx_r5.navContext.children);
} }
function B2CMobileHeaderComponent_div_13_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CMobileHeaderComponent_div_13_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CMobileHeaderComponent_div_13_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r54 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 42);
    ɵngcc0.ɵɵelementStart(1, "span", 43);
    ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 44);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "a", 45);
    ɵngcc0.ɵɵlistener("click", function B2CMobileHeaderComponent_div_13_div_4_Template_a_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r54); const ctx_r53 = ɵngcc0.ɵɵnextContext(2); return ctx_r53.toggleNavDrawer(); });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r51 = ctx.$implicit;
    const isLast_r52 = ctx.last;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c8, !isLast_r52));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("name", item_r51 == null ? null : item_r51.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", item_r51 == null ? null : item_r51.external, ɵngcc0.ɵɵsanitizeUrl)("title", item_r51 == null ? null : item_r51.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r51 == null ? null : item_r51.title);
} }
const _c11 = function (a1) { return { title: "Country/Region", fn: a1 }; };
function B2CMobileHeaderComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, B2CMobileHeaderComponent_div_13_ng_container_1_Template, 1, 0, "ng-container", 35);
    ɵngcc0.ɵɵelementStart(2, "div", 40);
    ɵngcc0.ɵɵtemplate(3, B2CMobileHeaderComponent_div_13_ng_container_3_Template, 1, 0, "ng-container", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, B2CMobileHeaderComponent_div_13_div_4_Template, 5, 7, "div", 41);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    const _r9 = ɵngcc0.ɵɵreference(17);
    const _r13 = ɵngcc0.ɵɵreference(21);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(4, _c11, ctx_r6.toggleNavCountry));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r13);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6._countries);
} }
function B2CMobileHeaderComponent_div_14_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CMobileHeaderComponent_div_14_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r59 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 47);
    ɵngcc0.ɵɵlistener("click", function B2CMobileHeaderComponent_div_14_div_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r59); const child_r57 = ctx.$implicit; const ctx_r58 = ɵngcc0.ɵɵnextContext(2); return ctx_r58.emitEvent(child_r57 == null ? null : child_r57.title, child_r57 == null ? null : child_r57.url, child_r57 == null ? null : child_r57.runOutsideAngular); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r57 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", child_r57 == null ? null : child_r57.title, " ");
} }
function B2CMobileHeaderComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, B2CMobileHeaderComponent_div_14_ng_container_1_Template, 1, 0, "ng-container", 35);
    ɵngcc0.ɵɵtemplate(2, B2CMobileHeaderComponent_div_14_div_2_Template, 2, 1, "div", 46);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    const _r9 = ɵngcc0.ɵɵreference(17);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(3, _c10, ctx_r7.navContext == null ? null : ctx_r7.navContext.title, ctx_r7.setNavContext));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.navContext == null ? null : ctx_r7.navContext.children);
} }
function B2CMobileHeaderComponent_div_15_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 52);
    ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 53);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("link", ctx_r60._facebook);
} }
function B2CMobileHeaderComponent_div_15_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 52);
    ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 54);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r61 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("link", ctx_r61._insta);
} }
function B2CMobileHeaderComponent_div_15_li_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 52);
    ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 55);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r62 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("link", ctx_r62._youtube);
} }
function B2CMobileHeaderComponent_div_15_li_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 52);
    ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 56);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r63 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("link", ctx_r63._telegram);
} }
function B2CMobileHeaderComponent_div_15_li_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 52);
    ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 57);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r64 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("link", ctx_r64._twitter);
} }
function B2CMobileHeaderComponent_div_15_a_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 52);
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 58);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r65 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("link", ctx_r65.appstore);
} }
function B2CMobileHeaderComponent_div_15_a_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 52);
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 59);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r66 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("link", ctx_r66.playstore);
} }
function B2CMobileHeaderComponent_div_15_ng_container_13_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CMobileHeaderComponent_div_15_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CMobileHeaderComponent_div_15_ng_container_13_ng_container_1_Template, 1, 0, "ng-container", 19);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r67 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r67.copyrightTemplate);
} }
function B2CMobileHeaderComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "ul", 48);
    ɵngcc0.ɵɵtemplate(2, B2CMobileHeaderComponent_div_15_li_2_Template, 3, 1, "li", 3);
    ɵngcc0.ɵɵtemplate(3, B2CMobileHeaderComponent_div_15_li_3_Template, 3, 1, "li", 3);
    ɵngcc0.ɵɵtemplate(4, B2CMobileHeaderComponent_div_15_li_4_Template, 3, 1, "li", 3);
    ɵngcc0.ɵɵtemplate(5, B2CMobileHeaderComponent_div_15_li_5_Template, 3, 1, "li", 3);
    ɵngcc0.ɵɵtemplate(6, B2CMobileHeaderComponent_div_15_li_6_Template, 3, 1, "li", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "ul", 49);
    ɵngcc0.ɵɵelementStart(8, "li");
    ɵngcc0.ɵɵtemplate(9, B2CMobileHeaderComponent_div_15_a_9_Template, 2, 1, "a", 50);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "li");
    ɵngcc0.ɵɵtemplate(11, B2CMobileHeaderComponent_div_15_a_11_Template, 2, 1, "a", 50);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "p", 51);
    ɵngcc0.ɵɵtemplate(13, B2CMobileHeaderComponent_div_15_ng_container_13_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8._facebook);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8._insta);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8._youtube);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8._telegram);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8._twitter);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.coerceBoolean(ctx_r8.appstore));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.coerceBoolean(ctx_r8.playstore));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.copyrightTemplate);
} }
const _c12 = function (a0) { return { "mb-3": a0 }; };
function B2CMobileHeaderComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 60);
    ɵngcc0.ɵɵelementStart(1, "h6", 61);
    ɵngcc0.ɵɵelementStart(2, "i", 62);
    ɵngcc0.ɵɵlistener("click", function B2CMobileHeaderComponent_ng_template_16_Template_i_click_2_listener() { const fn_r70 = ctx.fn; return fn_r70(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const title_r69 = ctx.title;
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c12, !ctx_r10.isOthers));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", title_r69, " ");
} }
function B2CMobileHeaderComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 63);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const title_r72 = ctx.title;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", title_r72, " ");
} }
function B2CMobileHeaderComponent_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 64);
    ɵngcc0.ɵɵelementStart(1, "span", 43);
    ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 44);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵelementStart(4, "span", 65);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "br");
    ɵngcc0.ɵɵelementStart(8, "span", 66);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("name", ctx_r14._country == null ? null : ctx_r14._country.icon);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 3, ctx_r14.I18nTransKey == null ? null : ctx_r14.I18nTransKey.CURRENT_COUNTRY));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r14._country == null ? null : ctx_r14._country.title);
} }
function B2CSimpleHeaderComponent_ng_container_0_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CSimpleHeaderComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5, 6);
    ɵngcc0.ɵɵtemplate(3, B2CSimpleHeaderComponent_ng_container_0_ng_container_1_ng_container_3_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "div", 8, 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const posEvent_r8 = ctx.ngIf;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r7.mobile ? "b2c-simple-header-mobile" : "b2c-simple-header-web")("ngStyle", ɵngcc0.ɵɵpureFunction1(3, _c6, (posEvent_r8 == null ? null : posEvent_r8.topHeight) + "px"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function B2CSimpleHeaderComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CSimpleHeaderComponent_ng_container_0_ng_container_1_Template, 6, 5, "ng-container", 4);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r0.positionEvent$));
} }
function B2CSimpleHeaderComponent_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CSimpleHeaderComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtemplate(1, B2CSimpleHeaderComponent_ng_template_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.mobile ? "b2c-simple-header-mobile" : "b2c-simple-header-web");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function B2CSimpleHeaderComponent_ng_template_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c13 = function (a0) { return { "text-center": a0 }; };
function B2CSimpleHeaderComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵtemplate(2, B2CSimpleHeaderComponent_ng_template_3_ng_container_2_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c13, ctx_r4.mobile));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5);
} }
function B2CSimpleHeaderComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "b2c-ui-icon", 13);
    ɵngcc0.ɵɵlistener("click", function B2CSimpleHeaderComponent_ng_template_5_Template_b2c_ui_icon_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.emitNavigationEvent(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("name", ctx_r6.mobile ? "fsmoneMobileLogoIcon" : "fsmoneLogoIcon");
} }
const defaultCountries = [
    { title: 'Malaysia', icon: 'malaysiaIcon', external: 'https://www.fsmone.com.my' },
    {
        title: 'Singapore',
        icon: 'singaporeIcon',
        external: 'https://secure.fundsupermart.com/fsm/home'
    },
    { title: 'Hong Kong', icon: 'hongKongIcon', external: 'https://secure.fundsupermart.com.hk' }
];
/** @type {?} */
const defaultProductCataloque = [
    { label: 'Unit Trusts', value: 'UT', icon: 'fundTypeIcon' },
    { label: 'Stocks & ETFs', value: 'STOCK', icon: 'stocksTypeIcon' },
    { label: 'ETFs', value: 'ETF', icon: 'etfsTypeIcon' },
    { label: 'Bonds', value: 'BOND', icon: 'bondsTypeIcon' },
    { label: 'Managed Portfolio', value: 'DPMS', icon: 'dpmsTypeIcon' },
    { label: 'Insurance', value: 'INSURANCE', icon: 'insuranceTypeIcon' },
    { label: 'Research Articles', value: 'Article', icon: 'researchArticleIcon' },
    { label: 'Support', value: 'Support', icon: 'supportIcon' },
    { label: 'FAQ', value: 'Faq', icon: 'faqIcon' }
];
/** @type {?} */
const OVERLAY_ID = 'b2c-search-overlay';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-header-search.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CHeaderSearchComponent {
    /**
     * @param {?} responsiveService
     * @param {?} fb
     */
    constructor(responsiveService, fb) {
        this.responsiveService = responsiveService;
        this.fb = fb;
        this.fullWidth = true;
        this.results = [
            { label: 'Eastspring Small Caps Fund', value: 'world' },
            { label: 'TA Global Tech Fund', value: 'world' },
            { label: 'Kenanga Growth Fund', value: 'world', subtitle: 'Kenanga Investment Berhad' },
            { label: 'Principal Asia Pacific Dynamic Income Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' },
            { label: 'United Global Fund', value: 'world' }
        ];
        this.searching = false;
        this.activationCount = 1;
        this.query = new EventEmitter();
        this.resultClick = new EventEmitter();
        this.nextPage = new EventEmitter();
        this._unitTrust = false;
        this._stock = false;
        this._etf = false;
        this._bond = false;
        this._dpms = false;
        this._insurance = false;
        this._article = false;
        this._faq = false;
        this.mobile = false;
        this.productCataloque = defaultProductCataloque;
        this.activeProductCataloque = [];
        this.height = (Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)) * 0.70;
        this.I18nTransKey = I18nTransKey;
        this.destroySubject = new Subject();
        this.responsiveService
            .isMobileWeb()
            .pipe(tap((/**
         * @param {?} mobile
         * @return {?}
         */
        (mobile) => (this.mobile = mobile))))
            .subscribe();
    }
    /**
     * @param {?} unitTrust
     * @return {?}
     */
    set unitTrust(unitTrust) {
        this._unitTrust = coerceBooleanProperty(unitTrust);
    }
    /**
     * @param {?} stock
     * @return {?}
     */
    set stock(stock) {
        this._stock = coerceBooleanProperty(stock);
        this.updateProductCatalogue();
    }
    /**
     * @param {?} etf
     * @return {?}
     */
    set etf(etf) {
        this._etf = coerceBooleanProperty(etf);
        this.updateProductCatalogue();
    }
    /**
     * @param {?} bond
     * @return {?}
     */
    set bond(bond) {
        this._bond = coerceBooleanProperty(bond);
        this.updateProductCatalogue();
    }
    /**
     * @param {?} dpms
     * @return {?}
     */
    set dpms(dpms) {
        this._dpms = coerceBooleanProperty(dpms);
        this.updateProductCatalogue();
    }
    /**
     * @param {?} insurance
     * @return {?}
     */
    set insurance(insurance) {
        this._insurance = coerceBooleanProperty(insurance);
        this.updateProductCatalogue();
    }
    /**
     * @param {?} article
     * @return {?}
     */
    set article(article) {
        this._article = coerceBooleanProperty(article);
        this.updateProductCatalogue();
    }
    /**
     * @param {?} faq
     * @return {?}
     */
    set faq(faq) {
        this._faq = coerceBooleanProperty(faq);
        this.updateProductCatalogue();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.form = this.fb.group({
            category: [this.productCataloque.find((/**
                 * @param {?} __0
                 * @return {?}
                 */
                ({ value }) => value === 'UT'))],
            query: ['']
        });
        this.form.valueChanges
            .pipe(filter((/**
         * @param {?} val
         * @return {?}
         */
        (val) => val.query && val.query.length > (this.activationCount || 0) && val.category)), debounceTime(500), tap((/**
         * @param {?} val
         * @return {?}
         */
        (val) => {
            /** @type {?} */
            const payload = Object.assign({}, val, { category: val.category.value });
            this.query.emit(payload);
        })), takeUntil(this.destroySubject))
            .subscribe();
        /** @type {?} */
        const searchOverlay = document.getElementById(OVERLAY_ID);
        if (searchOverlay) {
            fromEvent(searchOverlay, 'click')
                .pipe(tap((/**
             * @return {?}
             */
            () => {
                this.form.get('query').reset();
                this.results = [];
            })), takeUntil(this.destroySubject))
                .subscribe();
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroySubject.next();
        this.destroySubject.complete();
    }
    /**
     * @param {?} result
     * @return {?}
     */
    selectResult(result) {
        this.resultClick.emit(result);
        this.form.get('query').reset();
        this.results = [];
    }
    /**
     * @return {?}
     */
    focusTypeaheadInput() {
        if (this.typeaheadInput) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.typeaheadInput.nativeElement.focus();
            }), 0);
        }
    }
    /**
     * @return {?}
     */
    get queryField() {
        return this.form ? this.form.get('query').value : '';
    }
    /**
     * @private
     * @return {?}
     */
    updateProductCatalogue() {
        /** @type {?} */
        const cataloque = [];
        if (this._unitTrust) {
            cataloque.push(this.productCataloque.find((/**
             * @param {?} __0
             * @return {?}
             */
            ({ value }) => value === 'UT')));
        }
        if (this._stock) {
            cataloque.push(this.productCataloque.find((/**
             * @param {?} __0
             * @return {?}
             */
            ({ value }) => value === 'STOCK')));
        }
        if (this._bond) {
            cataloque.push(this.productCataloque.find((/**
             * @param {?} __0
             * @return {?}
             */
            ({ value }) => value === 'BOND')));
        }
        if (this._dpms) {
            cataloque.push(this.productCataloque.find((/**
             * @param {?} __0
             * @return {?}
             */
            ({ value }) => value === 'DPMS')));
        }
        if (this._insurance) {
            cataloque.push(this.productCataloque.find((/**
             * @param {?} __0
             * @return {?}
             */
            ({ value }) => value === 'INSURANCE')));
        }
        if (this._article) {
            cataloque.push(this.productCataloque.find((/**
             * @param {?} __0
             * @return {?}
             */
            ({ value }) => value === 'Article')));
        }
        if (this._faq) {
            cataloque.push(this.productCataloque.find((/**
             * @param {?} __0
             * @return {?}
             */
            ({ value }) => value === 'Faq')));
        }
        if (this._etf) {
            cataloque.push(this.productCataloque.find((/**
             * @param {?} __0
             * @return {?}
             */
            ({ value }) => value === 'ETF')));
        }
        this.activeProductCataloque = [...cataloque];
    }
}
B2CHeaderSearchComponent.ɵfac = function B2CHeaderSearchComponent_Factory(t) { return new (t || B2CHeaderSearchComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.FormBuilder)); };
B2CHeaderSearchComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CHeaderSearchComponent, selectors: [["b2c-header-search"]], viewQuery: function B2CHeaderSearchComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.typeaheadInput = _t.first);
    } }, hostVars: 2, hostBindings: function B2CHeaderSearchComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("w-100", ctx.fullWidth);
    } }, inputs: { results: "results", searching: "searching", activationCount: "activationCount", unitTrust: "unitTrust", stock: "stock", etf: "etf", bond: "bond", dpms: "dpms", insurance: "insurance", article: "article", faq: "faq" }, outputs: { query: "query", resultClick: "resultClick", nextPage: "nextPage" }, decls: 9, vars: 11, consts: [[1, "b2c-global-search-container", "w-100", "py-1", "d-flex", "position-relative", 3, "ngClass", "formGroup"], [4, "ngIf", "ngIfElse"], ["webTemplate", ""], [1, "flex-grow-1", "ml-2"], ["nz-input", "", "formControlName", "query", 1, "typeahead", 3, "placeholder"], ["typeahead", ""], ["class", "position-absolute", 3, "ngClass", 4, "ngIf"], ["formControlName", "category", "title", "Select Search Category", 3, "single", "selectedTemplate", "transparent"], [3, "value", 4, "ngFor", "ngForOf"], ["customMobileSelectTemplate", ""], [3, "value"], [1, "b2c-search-category", "mr-3", 3, "name"], [3, "name"], ["formControlName", "category", 2, "width", "250px", 3, "nzCustomTemplate"], ["nzCustomContent", "", "class", "py-2", 3, "nzLabel", "nzValue", 4, "ngFor", "ngForOf"], ["customSelectTemplate", ""], ["nzCustomContent", "", 1, "py-2", 3, "nzLabel", "nzValue"], ["class", "text-black", 4, "ngIf"], [1, "text-black"], [1, "position-absolute", 3, "ngClass"], [3, "maxHeight", "scrolled"], ["statusTemplate", ""], ["noResultTemplate", ""], ["class", "my-2 pointer p-1 result", 3, "click", 4, "ngFor", "ngForOf"], [1, "my-2", "pointer", "p-1", "result", 3, "click"], [3, "innerHTML"], [4, "ngIf"], ["class", "d-flex justify-content-center py-4", "style", "height: 60px;", 4, "ngIf", "ngIfElse"], [1, "d-flex", "justify-content-center", "py-4", 2, "height", "60px"], ["nzSimple", "", 1, "d-inline"], [1, "text-black-5", "ml-2"], [1, "text-center", "text-black-5", "py-3"]], template: function B2CHeaderSearchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, B2CHeaderSearchComponent_div_1_Template, 5, 4, "div", 1);
        ɵngcc0.ɵɵtemplate(2, B2CHeaderSearchComponent_ng_template_2_Template, 5, 2, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelement(5, "input", 4, 5);
        ɵngcc0.ɵɵpipe(7, "b2cI18n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, B2CHeaderSearchComponent_div_8_Template, 7, 4, "div", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(8, _c1, !ctx.mobile, !ctx.mobile))("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mobile)("ngIfElse", _r1);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(7, 6, ctx.I18nTransKey == null ? null : ctx.I18nTransKey.SEARCH_PLACEHOLDER));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.queryField == null ? null : ctx.queryField.length) > ctx.activationCount);
    } }, directives: function () { return [ɵngcc3.NgClass, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc3.NgIf, ɵngcc2.DefaultValueAccessor, ɵngcc4.NzInputDirective, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc5.B2CMobileSelectComponent, ɵngcc3.NgForOf, ɵngcc5.B2CMobileSelectOptionComponent, ɵngcc6.B2CUiIconComponent, ɵngcc7.NzSelectComponent, ɵngcc7.NzOptionComponent, ɵngcc8.B2CInfiniteScrollComponent, ɵngcc9.NzSpinComponent]; }, pipes: function () { return [ɵngcc10.B2CI18nPipe, B2CSearchHitPipe]; }, encapsulation: 2 });
/** @nocollapse */
B2CHeaderSearchComponent.ctorParameters = () => [
    { type: ResponsiveService },
    { type: FormBuilder }
];
B2CHeaderSearchComponent.propDecorators = {
    fullWidth: [{ type: HostBinding, args: ['class.w-100',] }],
    unitTrust: [{ type: Input }],
    stock: [{ type: Input }],
    etf: [{ type: Input }],
    bond: [{ type: Input }],
    dpms: [{ type: Input }],
    insurance: [{ type: Input }],
    article: [{ type: Input }],
    faq: [{ type: Input }],
    results: [{ type: Input }],
    searching: [{ type: Input }],
    activationCount: [{ type: Input }],
    query: [{ type: Output }],
    resultClick: [{ type: Output }],
    nextPage: [{ type: Output }],
    typeaheadInput: [{ type: ViewChild, args: ['typeahead', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CHeaderSearchComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-header-search',
                template: "<div class=\"b2c-global-search-container w-100 py-1 d-flex position-relative\" [ngClass]=\"{'ml-4': !mobile, 'px-3': !mobile}\" [formGroup]=\"form\">\r\n  <div *ngIf=\"mobile; else webTemplate\">\r\n    <b2c-mobile-select formControlName=\"category\" title=\"Select Search Category\" \r\n      [single]=\"true\" [selectedTemplate]=\"customMobileSelectTemplate\" [transparent]=\"true\">\r\n      <b2c-mobile-select-option *ngFor=\"let item of activeProductCataloque\" [value]=\"item\">\r\n        <span>\r\n          <b2c-ui-icon [name]=\"item?.icon\" class=\"b2c-search-category mr-3\"></b2c-ui-icon>\r\n          {{ item?.label }}\r\n        </span>\r\n      </b2c-mobile-select-option>\r\n    </b2c-mobile-select>\r\n\r\n    <ng-template #customMobileSelectTemplate let-selected=\"selected\">\r\n      <span>\r\n        <b2c-ui-icon [name]=\"selected?.value?.icon\"></b2c-ui-icon>\r\n      </span>\r\n    </ng-template>\r\n  </div>\r\n  <ng-template #webTemplate>\r\n    <div>\r\n      <nz-select style=\"width: 250px;\" [nzCustomTemplate]=\"customSelectTemplate\" formControlName=\"category\">\r\n        <nz-option nzCustomContent [nzLabel]=\"item?.label\" [nzValue]=\"item\" *ngFor=\"let item of activeProductCataloque\" class=\"py-2\">\r\n          <b2c-ui-icon [name]=\"item?.icon\" class=\"b2c-search-category mr-3\"></b2c-ui-icon>\r\n          {{ item?.label }}\r\n        </nz-option>\r\n      </nz-select>\r\n  \r\n      <ng-template #customSelectTemplate let-selected>\r\n        <b2c-ui-icon [name]=\"selected?.nzValue?.icon\" class=\"b2c-search-category mr-3\"></b2c-ui-icon>\r\n        <span class=\"text-black\" *ngIf=\"!mobile\">{{ selected?.nzLabel }}</span>\r\n      </ng-template>\r\n    </div>\r\n  </ng-template>\r\n  \r\n  <div class=\"flex-grow-1 ml-2\">\r\n    <input nz-input [placeholder]=\"I18nTransKey?.SEARCH_PLACEHOLDER | b2cI18n\" class=\"typeahead\" formControlName=\"query\" #typeahead/>\r\n  </div>\r\n\r\n  <div class=\"position-absolute\" [ngClass]=\"mobile ? 'search-result-mobile' : 'search-result-web'\" *ngIf=\"(queryField?.length > activationCount)\">\r\n    <b2c-infinite-scroll (scrolled)=\"nextPage.emit()\" [maxHeight]=\"mobile ? height : 400\">\r\n      <ng-container *ngIf=\"results?.length && !searching; else statusTemplate\">\r\n        <div *ngFor=\"let item of results\" class=\"my-2 pointer p-1 result\" (click)=\"selectResult(item)\">\r\n          <span [innerHTML]=\"item?.label | searchHit:queryField\"></span>\r\n          <ng-container *ngIf=\"item?.subtitle\">\r\n            <br>\r\n            <span>{{ item?.subtitle }}</span>\r\n          </ng-container>\r\n        </div>\r\n      </ng-container>\r\n      <ng-template #statusTemplate>\r\n        <div class=\"d-flex justify-content-center py-4\" style=\"height: 60px;\" *ngIf=\"searching; else noResultTemplate\">\r\n          <nz-spin nzSimple class=\"d-inline\"></nz-spin>\r\n          <span class='text-black-5 ml-2'>{{ I18nTransKey?.SEARCHING | b2cI18n }}</span>\r\n        </div>\r\n      </ng-template>\r\n\r\n      <ng-template #noResultTemplate>\r\n        <div class=\"text-center text-black-5 py-3\">\r\n          {{ I18nTransKey?.SEARCH_NO_RESULT | b2cI18n }}\r\n        </div>\r\n      </ng-template>\r\n      \r\n    </b2c-infinite-scroll>\r\n  </div>\r\n</div>"
            }]
    }], function () { return [{ type: ɵngcc1.ResponsiveService }, { type: ɵngcc2.FormBuilder }]; }, { fullWidth: [{
            type: HostBinding,
            args: ['class.w-100']
        }], results: [{
            type: Input
        }], searching: [{
            type: Input
        }], activationCount: [{
            type: Input
        }], query: [{
            type: Output
        }], resultClick: [{
            type: Output
        }], nextPage: [{
            type: Output
        }], unitTrust: [{
            type: Input
        }], stock: [{
            type: Input
        }], etf: [{
            type: Input
        }], bond: [{
            type: Input
        }], dpms: [{
            type: Input
        }], insurance: [{
            type: Input
        }], article: [{
            type: Input
        }], faq: [{
            type: Input
        }], typeaheadInput: [{
            type: ViewChild,
            args: ['typeahead', { static: true }]
        }] }); })();
if (false) {
    /** @type {?} */
    B2CHeaderSearchComponent.prototype.fullWidth;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype.results;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype.searching;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype.activationCount;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype.query;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype.resultClick;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype.nextPage;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype._unitTrust;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype._stock;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype._etf;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype._bond;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype._dpms;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype._insurance;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype._article;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype._faq;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype.mobile;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype.productCataloque;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype.activeProductCataloque;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype.form;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype.height;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype.typeaheadInput;
    /** @type {?} */
    B2CHeaderSearchComponent.prototype.I18nTransKey;
    /**
     * @type {?}
     * @private
     */
    B2CHeaderSearchComponent.prototype.destroySubject;
    /**
     * @type {?}
     * @private
     */
    B2CHeaderSearchComponent.prototype.responsiveService;
    /**
     * @type {?}
     * @private
     */
    B2CHeaderSearchComponent.prototype.fb;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-w-header.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CWebHeaderComponent {
    /**
     * @param {?} renderer
     * @param {?} hpService
     * @param {?} cdRef
     */
    constructor(renderer, hpService, cdRef) {
        this.renderer = renderer;
        this.hpService = hpService;
        this.cdRef = cdRef;
        this.structure = [
            { title: 'About Us', url: '/about', icon: 'aboutTypeIcon' },
            {
                title: 'Funds',
                url: '/funds',
                icon: 'fundTypeIcon',
                children: [
                    {
                        title: 'Get Started',
                        children: [
                            { title: 'Fund 101', url: '' },
                            { title: 'Fund 101', url: '' },
                            { title: 'Fund 101', url: '' },
                            { title: 'Fund 101', url: '' },
                            { title: 'Fund 101', url: '' },
                            { title: 'Fund 101', url: '' }
                        ]
                    },
                    {
                        title: 'Announcements',
                        children: [
                            { title: 'Income Distribution', url: '' },
                            { title: 'New Funds', url: '' },
                            { title: 'Fund Calendar', url: '' }
                        ]
                    },
                    {
                        title: 'Research',
                        children: [
                            { title: 'Recommended Funds', url: '' },
                            { title: 'Research Article', url: '' },
                            { title: 'Star Rating', url: '' },
                            { title: 'Market Indices', url: '' }
                        ]
                    }
                ]
            },
            {
                title: 'Stocks & ETFs',
                url: '/stocks',
                icon: 'stocksTypeIcon',
                children: []
            },
            {
                title: 'Bonds',
                url: '/bonds',
                children: [
                    {
                        title: 'Get Started',
                        children: [
                            {
                                title: 'Bond 101',
                                url: ''
                            },
                            {
                                title: 'Fees',
                                url: ''
                            },
                            {
                                title: 'Bond Ideas',
                                url: ''
                            },
                            {
                                title: 'Find My Bond',
                                url: ''
                            }
                        ]
                    },
                    {
                        title: 'Bond Express',
                        children: [
                            {
                                title: 'Retail Bonds',
                                url: ''
                            },
                            {
                                title: 'Wholesale Bonds',
                                url: ''
                            }
                        ]
                    },
                    {
                        title: 'Explore Bonds',
                        children: [
                            {
                                title: 'Lates Bonds',
                                url: ''
                            },
                            {
                                title: 'Corporate Bonds',
                                url: ''
                            },
                            {
                                title: 'Government Bonds',
                                url: ''
                            }
                        ]
                    }
                ]
            },
            {
                title: 'Managed Portfolio',
                url: '/mp',
                children: [
                    {
                        title: 'Get Started',
                        children: [
                            {
                                title: 'Bond 101',
                                url: ''
                            },
                            {
                                title: 'Fees',
                                url: ''
                            },
                            {
                                title: 'Bond Ideas',
                                url: ''
                            },
                            {
                                title: 'Find My Bond',
                                url: ''
                            }
                        ]
                    }
                ]
            },
            {
                title: 'Insurance',
                url: '/insurance',
                icon: 'insuranceTypeIcon',
                children: []
            }
        ];
        this.reflowFlag = false;
        this.navigate = new EventEmitter();
        this.reflowFlagChange = new EventEmitter();
        this.search = false;
        this.I18nTransKey = I18nTransKey;
        this.positionEvent$ = this.hpService.positionObs$;
        this.destroySubject = new Subject();
        window.scrollTo({
            top: 0,
            left: 0
        });
    }
    /**
     * @param {?} country
     * @return {?}
     */
    set country(country) {
        this._countries = defaultCountries.filter((/**
         * @param {?} __0
         * @return {?}
         */
        ({ title }) => title !== country.title));
        this._country = country;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const element = document.createElement('div');
        element.id = OVERLAY_ID;
        document.body.appendChild(element);
        this.searchOverlay = document.getElementById(OVERLAY_ID);
        fromEvent(this.searchOverlay, 'click')
            .pipe(filter((/**
         * @return {?}
         */
        () => this.search)), tap((/**
         * @return {?}
         */
        () => this.toggleSearch())), takeUntil(this.destroySubject))
            .subscribe();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.reflowFlag && this.reflowFlag) {
            this.hpService.reflow();
            this.reflowFlag = false;
            this.reflowFlagChange.emit(this.reflowFlag);
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.hpService.findHostWrapper(this.topWrapperId);
        this.hpService.initScroll();
        this.hpService.calculatePusherHeight(this.header, this.pusher);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.searchOverlay && this.searchOverlay.parentNode) {
            this.searchOverlay.parentNode.removeChild(this.searchOverlay);
        }
    }
    /**
     * @return {?}
     */
    toggleSearch() {
        this.search = !this.search;
        if (this.search) {
            if (this.searchComponent) {
                this.searchComponent.focusTypeaheadInput();
            }
            this.searchOverlay.classList.add('d-block');
        }
        else {
            this.searchOverlay.classList.remove('d-block');
        }
        this.cdRef.markForCheck();
        this.cdRef.detectChanges();
    }
    /**
     * @param {?} title
     * @param {?=} url
     * @param {?=} element
     * @param {?=} arrow
     * @param {?=} preventReset
     * @return {?}
     */
    emitNavigationEvent(title, url, element, arrow, preventReset) {
        this.navigate.emit({
            title,
            url
        });
        if (element) {
            this.renderer.setStyle(element, 'display', 'none');
            if (!preventReset) {
                setTimeout((/**
                 * @return {?}
                 */
                () => this.renderer.removeStyle(element, 'display')), 1);
            }
        }
        if (arrow) {
            this.renderer.setStyle(arrow, 'display', 'none');
        }
    }
    /**
     * @param {?} element
     * @param {?} arrow
     * @return {?}
     */
    resetMenuState(element, arrow) {
        if (element) {
            this.renderer.removeStyle(element, 'display');
        }
        if (arrow) {
            this.renderer.removeStyle(arrow, 'display');
        }
    }
    /**
     * @param {?} children
     * @return {?}
     */
    calculateGrid(children) {
        return children ? children.map((/**
         * @param {?} _
         * @return {?}
         */
        _ => '1fr')).join(' ') : '';
    }
}
B2CWebHeaderComponent.ɵfac = function B2CWebHeaderComponent_Factory(t) { return new (t || B2CWebHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.HeaderPositioningService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
B2CWebHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CWebHeaderComponent, selectors: [["b2c-web-header"]], contentQueries: function B2CWebHeaderComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, B2CHeaderSearchComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchComponent = _t.first);
    } }, viewQuery: function B2CWebHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, true);
        ɵngcc0.ɵɵviewQuery(_c3, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.header = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.pusher = _t.first);
    } }, inputs: { structure: "structure", reflowFlag: "reflowFlag", country: "country", appBarTemplates: "appBarTemplates", actionTemplates: "actionTemplates", topWrapperId: "topWrapperId" }, outputs: { navigate: "navigate", reflowFlagChange: "reflowFlagChange" }, features: [ɵngcc0.ɵɵProvidersFeature([HeaderPositioningService]), ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c7, decls: 4, vars: 3, consts: [["class", "b2c-web-header-wrapper position-fixed", 3, "ngStyle", 4, "ngIf"], [1, "w-100", "d-block", "b2c-web-pusher"], ["pusher", ""], [1, "b2c-web-header-wrapper", "position-fixed", 3, "ngStyle"], ["header", ""], [1, "b2c-web-header", "position-relative"], [1, "app-theme-bar", "w-100"], [1, "d-flex", "justify-content-end", "align-items-center", "container"], [1, "px-2", "pointer", "country", "position-relative"], [1, "text-white", "text-xs", "font-weight-bold"], ["nz-icon", "", "nzType", "global", "nzTheme", "outline", 1, "mr-1"], ["nz-icon", "", "nzType", "caret-down", "nzTheme", "fill", 1, "ml-1"], [1, "position-absolute", "country-selection", "pt-3", "pl-3", "pr-3", "pb-2", "bg-black-1"], [1, "w-100", "title", "mb-3"], [1, "text-uppercase", "text-theme", "font-weight-bold", "py-1", "ml-2"], [1, "d-flex", "flex-column", "p-0"], ["class", "mb-2 p-0", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "container", "py-1", "d-flex", "justify-content-between", "position-static", "align-items-center"], [1, "flex-grow-1"], [1, "d-flex", "align-items-center"], [2, "height", "55px"], ["name", "fsmoneLogoIcon", 1, "pointer", "h-100", 3, "click"], ["class", "nav ml-4 mb-0 p-0", 4, "ngIf"], ["class", "d-flex align-items-center", "style", "min-width: 100px;", 4, "ngIf"], [1, "mb-2", "p-0"], [1, "nav-icon", "mr-2"], [1, "icon-rounded-circle", "mr-1", 3, "name"], ["target", "_blank", "rel", "noreferrer noopener", 1, "text-sm", "country-item", 3, "href", "title"], ["class", "text-xs text-white font-weight-bold px-2 pointer", 4, "ngFor", "ngForOf"], [1, "text-xs", "text-white", "font-weight-bold", "px-2", "pointer"], [4, "ngTemplateOutlet"], [1, "nav", "ml-4", "mb-0", "p-0"], ["class", "px-2 py-1", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "menu-overlay"], [1, "px-2", "py-1", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["withoutDropdownTemplate", ""], [1, "font-weight-bold", "text-sm", "pointer", "position-relative", 3, "click", "mouseout"], [1, "pointing-arrow", "position-absolute"], ["arrow", ""], [1, "position-absolute", "w-100", "menu"], ["expandedMenu", ""], [1, "bg-black-1", "menu-container", "w-100"], [1, "container", "wrapper", "py-5", 3, "ngStyle"], ["class", "nav-list d-flex flex-column", "role", "navigation", 4, "ngFor", "ngForOf"], ["role", "navigation", 1, "nav-list", "d-flex", "flex-column"], [1, "title", "font-weight-bold", "mb-4"], ["class", "mb-3 item", 4, "ngFor", "ngForOf"], [1, "mb-3", "item"], [1, "text-sm", 3, "click"], [1, "font-weight-bold", "text-sm", 3, "click"], [1, "p-3", "pointer", "ml-4", 3, "click"], ["nz-icon", "", "nzType", "close", "nzTheme", "outline"], [1, "d-flex", "align-items-center", 2, "min-width", "100px"], [1, "mr-3", "pointer", 3, "click"], ["nz-icon", "", "nzType", "search", "nzTheme", "outline"], [4, "ngFor", "ngForOf"]], template: function B2CWebHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, B2CWebHeaderComponent_div_0_Template, 26, 12, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵelement(2, "div", 1, 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.positionEvent$));
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgStyle, ɵngcc11.NzIconDirective, ɵngcc3.NgForOf, ɵngcc6.B2CUiIconComponent, ɵngcc3.NgTemplateOutlet, ɵngcc3.NgClass], pipes: [ɵngcc3.AsyncPipe, ɵngcc10.B2CI18nPipe], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CWebHeaderComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: HeaderPositioningService },
    { type: ChangeDetectorRef }
];
B2CWebHeaderComponent.propDecorators = {
    appBarTemplates: [{ type: Input }],
    structure: [{ type: Input }],
    actionTemplates: [{ type: Input }],
    country: [{ type: Input }],
    topWrapperId: [{ type: Input }],
    reflowFlag: [{ type: Input }],
    navigate: [{ type: Output }],
    reflowFlagChange: [{ type: Output }],
    header: [{ type: ViewChild, args: ['header', { static: false },] }],
    pusher: [{ type: ViewChild, args: ['pusher', { static: false },] }],
    searchComponent: [{ type: ContentChild, args: [B2CHeaderSearchComponent, { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CWebHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-web-header',
                template: "<div class=\"b2c-web-header-wrapper position-fixed\" #header *ngIf=\"(positionEvent$ | async) as posEvent\" [ngStyle]=\"{'top': posEvent?.topHeight + 'px'}\">\r\n  <div class=\"b2c-web-header position-relative\">\r\n    <div class=\"app-theme-bar w-100\">\r\n      <div class=\"d-flex justify-content-end align-items-center container\">\r\n        <span class=\"px-2 pointer country position-relative\">\r\n          <a class=\"text-white text-xs font-weight-bold\">\r\n            <i nz-icon nzType=\"global\" nzTheme=\"outline\" class=\"mr-1\"></i>\r\n            {{ _country?.title }}\r\n            <i nz-icon nzType=\"caret-down\" nzTheme=\"fill\" class=\"ml-1\"></i>\r\n          </a>\r\n          <div class=\"position-absolute country-selection pt-3 pl-3 pr-3 pb-2 bg-black-1\">\r\n            <div class=\"w-100 title mb-3\">\r\n              <h6 class=\"text-uppercase text-theme font-weight-bold py-1 ml-2\">\r\n                {{ I18nTransKey?.SELECT_YOUR_COUNTRY | b2cI18n }}\r\n              </h6>\r\n            </div>\r\n\r\n            <ul class=\"d-flex flex-column p-0\">\r\n              <li class=\"mb-2 p-0\" *ngFor=\"let country of _countries\">\r\n                <span class=\"nav-icon mr-2\">\r\n                  <b2c-ui-icon [name]=\"country?.icon\" class=\"icon-rounded-circle mr-1\"></b2c-ui-icon>\r\n                  <a [href]=\"country?.external\" target=\"_blank\" class=\"text-sm country-item\" rel=\"noreferrer noopener\" [title]=\"country?.title\">\r\n                    {{ country?.title }}\r\n                  </a>\r\n                </span>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </span>\r\n        <ng-container *ngIf=\"appBarTemplates && appBarTemplates.length\">\r\n          <span class=\"text-xs text-white font-weight-bold px-2 pointer\" *ngFor=\"let template of appBarTemplates\">\r\n            <ng-container *ngTemplateOutlet=\"template\"></ng-container>\r\n          </span>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"container py-1 d-flex justify-content-between position-static align-items-center\">\r\n      <div class=\"flex-grow-1\">\r\n        <div class=\"d-flex align-items-center\">\r\n          <div style=\"height: 55px;\">\r\n            <b2c-ui-icon name=\"fsmoneLogoIcon\" class=\"pointer h-100\" (click)=\"emitNavigationEvent('title', '/')\"></b2c-ui-icon>\r\n          </div>\r\n\r\n          <ul class=\"nav ml-4 mb-0 p-0\" *ngIf=\"!search\">\r\n            <li *ngFor=\"let item of structure\" class=\"px-2 py-1\" [ngClass]=\"[structure?.length > 5 ? 'ml-1 mr-1' : 'ml-2 mr-2', item?.children ? 'has-dropdown-menu' : '']\">\r\n              <ng-container *ngIf=\"item?.children; else withoutDropdownTemplate\">\r\n                <a class=\"font-weight-bold text-sm pointer position-relative\" (click)=\"emitNavigationEvent(item?.title, item?.url, expandedMenu, arrow, true)\" (mouseout)=\"resetMenuState(expandedMenu, arrow)\">\r\n                  {{ item?.title }}\r\n                  <span class=\"pointing-arrow position-absolute\" #arrow></span>\r\n                </a>\r\n                <div class=\"position-absolute w-100 menu\" #expandedMenu>\r\n                  <div class=\"bg-black-1 menu-container w-100\">\r\n                    <div class=\"container wrapper py-5\" [ngStyle]=\"{'gridTemplateColumns': calculateGrid(item?.children)}\">\r\n                      <ul class=\"nav-list d-flex flex-column\" *ngFor=\"let child of item?.children\" role=\"navigation\">\r\n                        <li class=\"title font-weight-bold mb-4\">{{ child?.title }}</li>\r\n                        <li class=\"mb-3 item\" *ngFor=\"let grandChild of child?.children\">\r\n                          <a class=\"text-sm\" (click)=\"emitNavigationEvent(grandChild?.title, grandChild?.url, expandedMenu)\">{{ grandChild?.title }}</a>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </ng-container>\r\n              <ng-template #withoutDropdownTemplate>\r\n                <a class=\"font-weight-bold text-sm\" (click)=\"emitNavigationEvent(item?.title, item?.url)\">{{ item?.title }}</a>\r\n              </ng-template>\r\n            </li>\r\n            <li class=\"menu-overlay\">\r\n\r\n            </li>\r\n          </ul>\r\n\r\n          <ng-container *ngIf=\"search\">\r\n            <ng-content></ng-content>\r\n            <div class=\"p-3 pointer ml-4\" (click)=\"toggleSearch()\">\r\n              <i nz-icon nzType=\"close\" nzTheme=\"outline\"></i>\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"!search\" class=\"d-flex align-items-center\" style=\"min-width: 100px;\">\r\n        <!-- search bar -->\r\n        <span class=\"mr-3 pointer\" (click)=\"toggleSearch()\">\r\n          <i nz-icon nzType=\"search\" nzTheme=\"outline\"></i>\r\n        </span>\r\n\r\n        <!-- actions e.g. open account -->\r\n        <ng-container *ngIf=\"actionTemplates\">\r\n          <ng-container *ngFor=\"let template of actionTemplates\">\r\n            <ng-container *ngTemplateOutlet=\"template\"></ng-container>\r\n          </ng-container>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"w-100 d-block b2c-web-pusher\" #pusher></div>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [HeaderPositioningService]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc1.HeaderPositioningService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { structure: [{
            type: Input
        }], reflowFlag: [{
            type: Input
        }], navigate: [{
            type: Output
        }], reflowFlagChange: [{
            type: Output
        }], country: [{
            type: Input
        }], appBarTemplates: [{
            type: Input
        }], actionTemplates: [{
            type: Input
        }], topWrapperId: [{
            type: Input
        }], header: [{
            type: ViewChild,
            args: ['header', { static: false }]
        }], pusher: [{
            type: ViewChild,
            args: ['pusher', { static: false }]
        }], searchComponent: [{
            type: ContentChild,
            args: [B2CHeaderSearchComponent, { static: true }]
        }] }); })();
if (false) {
    /** @type {?} */
    B2CWebHeaderComponent.prototype.appBarTemplates;
    /** @type {?} */
    B2CWebHeaderComponent.prototype.structure;
    /** @type {?} */
    B2CWebHeaderComponent.prototype.actionTemplates;
    /** @type {?} */
    B2CWebHeaderComponent.prototype.topWrapperId;
    /** @type {?} */
    B2CWebHeaderComponent.prototype.reflowFlag;
    /** @type {?} */
    B2CWebHeaderComponent.prototype.navigate;
    /** @type {?} */
    B2CWebHeaderComponent.prototype.reflowFlagChange;
    /** @type {?} */
    B2CWebHeaderComponent.prototype.header;
    /** @type {?} */
    B2CWebHeaderComponent.prototype.pusher;
    /** @type {?} */
    B2CWebHeaderComponent.prototype.searchComponent;
    /** @type {?} */
    B2CWebHeaderComponent.prototype.search;
    /** @type {?} */
    B2CWebHeaderComponent.prototype.searchOverlay;
    /** @type {?} */
    B2CWebHeaderComponent.prototype._country;
    /** @type {?} */
    B2CWebHeaderComponent.prototype._countries;
    /** @type {?} */
    B2CWebHeaderComponent.prototype.I18nTransKey;
    /** @type {?} */
    B2CWebHeaderComponent.prototype.positionEvent$;
    /**
     * @type {?}
     * @private
     */
    B2CWebHeaderComponent.prototype.destroySubject;
    /**
     * @type {?}
     * @private
     */
    B2CWebHeaderComponent.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    B2CWebHeaderComponent.prototype.hpService;
    /**
     * @type {?}
     * @private
     */
    B2CWebHeaderComponent.prototype.cdRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-m-header.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CMobileHeaderComponent {
    /**
     * @param {?} cdRef
     */
    constructor(cdRef) {
        this.cdRef = cdRef;
        this.structure = [
            { title: 'About', url: '/about', icon: 'aboutTypeIcon' },
            {
                title: 'Funds',
                url: '/funds',
                icon: 'fundTypeIcon',
                children: [
                    {
                        title: 'Get Started',
                        children: [
                            { title: 'Fund 101', url: '' },
                            { title: 'Fund 101', url: '' },
                            { title: 'Fund 101', url: '' },
                            { title: 'Fund 101', url: '' },
                            { title: 'Fund 101', url: '' },
                            { title: 'Fund 101', url: '' }
                        ]
                    },
                    {
                        title: 'Announcements',
                        children: [
                            { title: 'Income Distribution', url: '' },
                            { title: 'New Funds', url: '' },
                            { title: 'Fund Calendar', url: '' }
                        ]
                    },
                    {
                        title: 'Research',
                        children: [
                            { title: 'Recommended Funds', url: '' },
                            { title: 'Research Article', url: '' },
                            { title: 'Star Rating', url: '' },
                            { title: 'Market Indices', url: '' }
                        ]
                    }
                ]
            }
        ];
        this.others = {
            title: 'Others',
            children: [
                { title: 'Sitemap', url: '' },
                { title: 'Privacy Policy', url: '' },
                { title: 'Careers', url: '' },
                { title: 'Disclaimer', url: '' },
                { title: 'Investment Acc Terms & Condition', url: '' }
            ]
        };
        this.onSearch = new EventEmitter();
        this.clicked = new EventEmitter();
        this.showTitle = false;
        this.pageTitle = '';
        this.navDrawer = false;
        this.navContext = null;
        this.navCountry = false;
        this.isOthers = false;
        this._countries = [];
        this.I18nTransKey = I18nTransKey;
        this.setNavContext = (/**
         * @param {?=} context
         * @param {?=} isOthers
         * @return {?}
         */
        (context, isOthers = false) => {
            this.isOthers = isOthers;
            this.navContext = context || null;
            this.cdRef.markForCheck();
        });
        this.toggleNavCountry = (/**
         * @return {?}
         */
        () => {
            this.navCountry = !this.navCountry;
            this.cdRef.markForCheck();
        });
        window.scrollTo({
            top: 0,
            left: 0
        });
    }
    /**
     * @param {?} country
     * @return {?}
     */
    set country(country) {
        this._countries = defaultCountries.filter((/**
         * @param {?} __0
         * @return {?}
         */
        ({ title }) => title !== country.title));
        this._country = country;
    }
    /**
     * Set Facebook Icon Url
     * @param {?} value
     * @return {?}
     */
    set facebook(value) {
        this._facebook = this.completeLink(value);
    }
    /**
     * Set Instagram Icon Url
     * @param {?} value
     * @return {?}
     */
    set insta(value) {
        this._insta = this.completeLink(value);
    }
    /**
     * Set Youtube Icon Url
     * @param {?} value
     * @return {?}
     */
    set youtube(value) {
        this._youtube = this.completeLink(value);
    }
    /**
     * Set telegram Icon Url
     * @param {?} value
     * @return {?}
     */
    set tele(value) {
        this._telegram = this.completeLink(value);
    }
    /**
     * Set twitter Icon Url
     * @param {?} value
     * @return {?}
     */
    set twitter(value) {
        this._twitter = this.completeLink(value);
    }
    /**
     * @return {?}
     */
    determineShowTitle() {
        return this.showTitle;
    }
    /**
     * @return {?}
     */
    toggleNavDrawer() {
        this.navDrawer = !this.navDrawer;
        this.navContext = null;
        this.navCountry = false;
    }
    /**
     * @param {?} title
     * @param {?=} url
     * @param {?=} runOutsideAngular
     * @return {?}
     */
    emitEvent(title, url, runOutsideAngular) {
        this.clicked.emit({
            title,
            url,
            runOutsideAngular
        });
        this.toggleNavDrawer();
    }
    /**
     * @ignore
     * @param {?} value
     * @return {?}
     */
    coerceBoolean(value) {
        return coerceBooleanProperty(value);
    }
    /**
     * @private
     * @param {?} link
     * @return {?}
     */
    completeLink(link) {
        /** @type {?} */
        const regex = new RegExp('(http://)|(https://)', 'gmi');
        return regex.test(link) ? link : `https://${link}`;
    }
}
B2CMobileHeaderComponent.ɵfac = function B2CMobileHeaderComponent_Factory(t) { return new (t || B2CMobileHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
B2CMobileHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CMobileHeaderComponent, selectors: [["b2c-mobile-header"]], inputs: { structure: "structure", others: "others", showTitle: "showTitle", pageTitle: "pageTitle", country: "country", facebook: "facebook", insta: "insta", youtube: "youtube", tele: "tele", twitter: "twitter", logoLink: "logoLink", copyrightTemplate: "copyrightTemplate", appstore: "appstore", playstore: "playstore", notificationTemplate: "notificationTemplate" }, outputs: { onSearch: "onSearch", clicked: "clicked" }, features: [ɵngcc0.ɵɵProvidersFeature([HeaderPositioningService])], decls: 22, vars: 12, consts: [[1, "d-block", "w-100", "bg-white", "b2c-mobile-header", "mb-1", "pt-2", "pb-2"], [1, "container", "d-flex", "justify-content-between", "align-items-center"], ["role", "navigation", 1, "mobile-menu", "pointer", 3, "click"], [4, "ngIf"], ["nz-icon", "", "nzType", "search", "nzTheme", "outline", "class", "pointer", 3, "click", 4, "ngIf"], ["nzPlacement", "left", 3, "nzVisible", "nzClosable", "nzWrapClassName", "nzOnClose"], ["class", "px-2", 4, "ngIf"], ["navDetailsTemplate", ""], ["navTitleTemplate", ""], ["currentCountryTemplate", ""], [1, "h4", "font-weight-bold", "text-center", "w-100", "mb-0"], ["name", "fsmoneMobileLogoIcon", 4, "ngIf"], ["name", "fsmoneMobileLogoIcon", 3, "routerLink", 4, "ngIf"], ["name", "fsmoneMobileLogoIcon"], ["name", "fsmoneMobileLogoIcon", 3, "routerLink"], ["nz-icon", "", "nzType", "search", "nzTheme", "outline", 1, "pointer", 3, "click"], ["nz-row", "", "nzType", "flex", "nzJustify", "end"], ["nz-col", ""], ["nz-icon", "", "nzType", "search", "nzTheme", "outline", 1, "pointer", "mr-3", 3, "click"], [4, "ngTemplateOutlet"], [1, "px-2"], [4, "ngFor", "ngForOf"], [1, "d-flex", "align-items-center", "justify-content-between", "border-bottom", 3, "click"], [1, "text-theme", "text-md"], ["nz-icon", "", "nzType", "right", "nzTheme", "outline"], [1, "py-2", "pointer"], [1, "d-flex", "align-items-center", "justify-content-between", 3, "click"], [1, "d-flex", "align-items-center"], [1, "text-sm", "mb-0", "ml-3", "font-weight-bold"], [1, "border-bottom", "py-2", "pointer"], [4, "ngIf", "ngIfElse"], ["withoutDropdownTemplate", ""], [1, "nav-icon"], [3, "name"], [1, "d-flex", "align-items-center", 3, "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "mb-3", 4, "ngFor", "ngForOf"], [1, "mb-3"], ["class", "navbar-item py-3 pointer text-sm", "role", "link", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["role", "link", 1, "navbar-item", "py-3", "pointer", "text-sm", 3, "ngClass", "click"], [1, "nav-title", "bg-black-3", "pt-2", "pb-2", "pl-3"], ["class", "navbar-item py-3 pointer text-sm", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "navbar-item", "py-3", "pointer", "text-sm", 3, "ngClass"], [1, "nav-icon", "mr-3", "icon-rounded-circle"], [1, "icon-rounded-circle", 3, "name"], ["target", "_blank", "rel", "noreferrer noopener", 1, "text-black", 3, "href", "title", "click"], ["class", "navbar-item py-3 pointer text-sm border-bottom", "role", "link", 3, "click", 4, "ngFor", "ngForOf"], ["role", "link", 1, "navbar-item", "py-3", "pointer", "text-sm", "border-bottom", 3, "click"], [1, "b2c-social-media", "my-1", "pb-3"], [1, "list-inline", "pb-3"], ["external", "", 3, "link", 4, "ngIf"], [1, "b2c-copyright", "pl-2"], ["external", "", 3, "link"], ["name", "iconFacebookFillIcon"], ["name", "iconInstagramFillIcon"], ["name", "iconYoutubeFillIcon"], ["name", "iconTelegramFillIcon"], ["name", "iconTwitterFillIcon"], ["name", "footerAppstoreIcon"], ["name", "footerPlaystoreIcon"], [1, "px-2", "py-2", "padding", 3, "ngClass"], [1, "font-weight-bold", "text-base"], ["nz-icon", "", "nzType", "arrow-left", "nzTheme", "outline", 1, "pointer", "mr-2", 3, "click"], [1, "nav-title", "bg-black-3", "text-uppercase", "pt-1", "pb-1", "font-weight-bold", "text-xs", "d-block", "w-100", "pl-3"], [1, "d-flex", "align-items-center", "py-2", "pointer"], [1, "text-black-6", "text-xs"], [1, "font-weight-bold", "text-sm", "country-title", "d-block"]], template: function B2CMobileHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵlistener("click", function B2CMobileHeaderComponent_Template_div_click_2_listener() { return ctx.toggleNavDrawer(); });
        ɵngcc0.ɵɵelement(3, "div");
        ɵngcc0.ɵɵelement(4, "div");
        ɵngcc0.ɵɵelement(5, "div");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, B2CMobileHeaderComponent_ng_container_6_Template, 3, 1, "ng-container", 3);
        ɵngcc0.ɵɵtemplate(7, B2CMobileHeaderComponent_ng_container_7_Template, 3, 2, "ng-container", 3);
        ɵngcc0.ɵɵtemplate(8, B2CMobileHeaderComponent_i_8_Template, 1, 0, "i", 4);
        ɵngcc0.ɵɵtemplate(9, B2CMobileHeaderComponent_ng_container_9_Template, 5, 1, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "nz-drawer", 5);
        ɵngcc0.ɵɵlistener("nzOnClose", function B2CMobileHeaderComponent_Template_nz_drawer_nzOnClose_10_listener() { return ctx.toggleNavDrawer(); });
        ɵngcc0.ɵɵtemplate(11, B2CMobileHeaderComponent_div_11_Template, 13, 3, "div", 6);
        ɵngcc0.ɵɵtemplate(12, B2CMobileHeaderComponent_div_12_Template, 3, 6, "div", 3);
        ɵngcc0.ɵɵtemplate(13, B2CMobileHeaderComponent_div_13_Template, 5, 6, "div", 3);
        ɵngcc0.ɵɵtemplate(14, B2CMobileHeaderComponent_div_14_Template, 3, 6, "div", 3);
        ɵngcc0.ɵɵtemplate(15, B2CMobileHeaderComponent_div_15_Template, 14, 8, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, B2CMobileHeaderComponent_ng_template_16_Template, 5, 4, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(18, B2CMobileHeaderComponent_ng_template_18_Template, 2, 1, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(20, B2CMobileHeaderComponent_ng_template_20_Template, 10, 5, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.determineShowTitle());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.determineShowTitle());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.notificationTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.notificationTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("nzVisible", ctx.navDrawer)("nzClosable", false)("nzWrapClassName", ctx.navContext || ctx.navCountry ? "b2c-mobile-navbar-details" : "b2c-mobile-navbar");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.navContext && !ctx.navCountry);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isOthers && ctx.navContext && !ctx.navCountry);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.navCountry);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOthers && ctx.navContext && !ctx.navCountry);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.navContext && !ctx.navCountry);
    } }, directives: [ɵngcc3.NgIf, ɵngcc12.NzDrawerComponent, ɵngcc6.B2CUiIconComponent, ɵngcc13.RouterLink, ɵngcc11.NzIconDirective, ɵngcc14.NzRowDirective, ɵngcc14.NzColDirective, ɵngcc3.NgTemplateOutlet, ɵngcc3.NgForOf, ɵngcc3.NgClass, ɵngcc1.ExternalLinkDirective], pipes: [ɵngcc10.B2CI18nPipe], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CMobileHeaderComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
B2CMobileHeaderComponent.propDecorators = {
    structure: [{ type: Input }],
    others: [{ type: Input }],
    onSearch: [{ type: Output }],
    clicked: [{ type: Output }],
    country: [{ type: Input }],
    showTitle: [{ type: Input }],
    pageTitle: [{ type: Input }],
    logoLink: [{ type: Input }],
    copyrightTemplate: [{ type: Input }],
    facebook: [{ type: Input }],
    insta: [{ type: Input }],
    youtube: [{ type: Input }],
    tele: [{ type: Input }],
    twitter: [{ type: Input }],
    appstore: [{ type: Input }],
    playstore: [{ type: Input }],
    notificationTemplate: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CMobileHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-mobile-header',
                template: "<div class=\"d-block w-100 bg-white b2c-mobile-header mb-1 pt-2 pb-2\" >\r\n  <div class=\"container d-flex justify-content-between align-items-center\">\r\n    <div class=\"mobile-menu pointer\" role=\"navigation\" (click)=\"toggleNavDrawer()\">\r\n      <div></div>\r\n      <div></div>\r\n      <div></div>\r\n    </div>\r\n    <ng-container *ngIf=\"determineShowTitle()\">\r\n      <p class=\"h4 font-weight-bold text-center w-100 mb-0\">{{ pageTitle }}</p>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"!determineShowTitle()\">\r\n      <b2c-ui-icon *ngIf=\"!coerceBoolean(logoLink)\" name=\"fsmoneMobileLogoIcon\"></b2c-ui-icon>\r\n      <b2c-ui-icon *ngIf=\"coerceBoolean(logoLink)\" [routerLink]=\"logoLink\" name=\"fsmoneMobileLogoIcon\"></b2c-ui-icon>\r\n    </ng-container>\r\n    <i *ngIf=!notificationTemplate nz-icon nzType=\"search\" nzTheme=\"outline\" class=\"pointer\" (click)=\"onSearch.emit()\"></i>\r\n    <ng-container *ngIf=\"notificationTemplate\">\r\n      <div nz-row nzType=\"flex\" nzJustify=\"end\">\r\n        <div nz-col>\r\n          <i nz-icon nzType=\"search\" nzTheme=\"outline\" class=\"pointer mr-3\" (click)=\"onSearch.emit()\"></i>\r\n          <ng-container *ngTemplateOutlet=\"notificationTemplate\"></ng-container>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n\r\n\r\n<nz-drawer nzPlacement=\"left\" [nzVisible]=\"navDrawer\" [nzClosable]=\"false\"\r\n           (nzOnClose)=\"toggleNavDrawer()\" [nzWrapClassName]=\"(navContext || navCountry) ? 'b2c-mobile-navbar-details' : 'b2c-mobile-navbar'\">\r\n  <div class=\"px-2\" *ngIf=\"!navContext && !navCountry\">\r\n    <ng-container *ngFor=\"let item of structure\">\r\n      <div class=\"border-bottom py-2 pointer\">\r\n        <ng-container *ngIf=\"item?.children; else withoutDropdownTemplate\">\r\n          <div class=\"d-flex align-items-center justify-content-between\" (click)=\"setNavContext(item)\">\r\n            <div class=\"d-flex align-items-center\">\r\n              <span class=\"nav-icon\">\r\n                <b2c-ui-icon [name]=\"item?.icon\"></b2c-ui-icon>\r\n              </span>\r\n              <h5 class=\"text-sm mb-0 ml-3 font-weight-bold\">{{ item?.title }}</h5>\r\n            </div>\r\n            <span class=\"text-theme text-md\">\r\n              <i nz-icon nzType=\"right\" nzTheme=\"outline\"></i>\r\n            </span>\r\n          </div>\r\n        </ng-container>\r\n\r\n        <ng-template #withoutDropdownTemplate>\r\n          <div class=\"d-flex align-items-center\" (click)=\"emitEvent(item?.title, item?.url, item?.runOutsideAngular)\">\r\n            <span class=\"nav-icon\">\r\n              <b2c-ui-icon [name]=\"item?.icon\"></b2c-ui-icon>\r\n            </span>\r\n            <h5 class=\"text-sm mb-0 ml-3 font-weight-bold\">{{ item?.title }}</h5>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n    </ng-container>\r\n    <div class=\"d-flex align-items-center justify-content-between border-bottom\" (click)=\"toggleNavCountry()\">\r\n      <ng-container *ngTemplateOutlet=\"currentCountryTemplate\"></ng-container>\r\n      <span class=\"text-theme text-md\">\r\n        <i nz-icon nzType=\"right\" nzTheme=\"outline\"></i>\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"py-2 pointer\">\r\n      <div class=\"d-flex align-items-center justify-content-between\" (click)=\"setNavContext(others, true)\">\r\n        <div class=\"d-flex align-items-center\">\r\n          <h5 class=\"text-sm mb-0 ml-3 font-weight-bold\">{{ others.title }}</h5>\r\n        </div>\r\n        <span class=\"text-theme text-md\">\r\n          <i nz-icon nzType=\"right\" nzTheme=\"outline\"></i>\r\n        </span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"!isOthers && navContext && !navCountry\">\r\n    <ng-container *ngTemplateOutlet=\"navDetailsTemplate; context: { title: navContext?.title, fn: setNavContext }\"></ng-container>\r\n    <div class=\"mb-3\" *ngFor=\"let item of navContext?.children\">\r\n      <ng-container *ngTemplateOutlet=\"navTitleTemplate; context: { title: item?.title }\"></ng-container>\r\n      <div class=\"navbar-item py-3 pointer text-sm\" [ngClass]=\"{'border-bottom': !isLast}\" *ngFor=\"let child of item?.children; last as isLast\" (click)=\"emitEvent(child?.title, child?.url, child?.runOutsideAngular)\" role=\"link\">\r\n        {{ child?.title }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"navCountry\">\r\n    <ng-container *ngTemplateOutlet=\"navDetailsTemplate; context: { title: 'Country/Region', fn: toggleNavCountry }\"></ng-container>\r\n    <div class=\"nav-title bg-black-3 pt-2 pb-2 pl-3\">\r\n      <ng-container *ngTemplateOutlet=\"currentCountryTemplate\"></ng-container>\r\n    </div>\r\n    <div class=\"navbar-item py-3 pointer text-sm\" [ngClass]=\"{'border-bottom': !isLast}\" *ngFor=\"let item of _countries; last as isLast\">\r\n      <span class=\"nav-icon mr-3 icon-rounded-circle\">\r\n        <b2c-ui-icon [name]=\"item?.icon\" class=\"icon-rounded-circle\"></b2c-ui-icon>\r\n      </span>\r\n      <a [href]=\"item?.external\" target=\"_blank\" class=\"text-black\" rel=\"noreferrer noopener\" [title]=\"item?.title\" (click)=\"toggleNavDrawer()\">{{ item?.title }}</a>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"isOthers && navContext && !navCountry\">\r\n    <ng-container *ngTemplateOutlet=\"navDetailsTemplate; context: { title: navContext?.title, fn: setNavContext }\"></ng-container>\r\n    <div class=\"navbar-item py-3 pointer text-sm border-bottom\" *ngFor=\"let child of navContext?.children\" (click)=\"emitEvent(child?.title, child?.url, child?.runOutsideAngular)\" role=\"link\">\r\n      {{ child?.title }}\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"!navContext && !navCountry\" class=\"px-2\">\r\n    <ul class=\"b2c-social-media my-1 pb-3\">\r\n      <li *ngIf=\"_facebook\">\r\n        <a external [link]=\"_facebook\">\r\n          <b2c-ui-icon name=\"iconFacebookFillIcon\"></b2c-ui-icon>\r\n        </a>\r\n      </li>\r\n      <li *ngIf=\"_insta\">\r\n        <a external [link]=\"_insta\">\r\n          <b2c-ui-icon name=\"iconInstagramFillIcon\"></b2c-ui-icon>\r\n        </a>\r\n      </li>\r\n      <li *ngIf=\"_youtube\">\r\n        <a external [link]=\"_youtube\">\r\n          <b2c-ui-icon name=\"iconYoutubeFillIcon\"></b2c-ui-icon>\r\n        </a>\r\n      </li>\r\n      <li *ngIf=\"_telegram\">\r\n        <a external [link]=\"_telegram\">\r\n          <b2c-ui-icon name=\"iconTelegramFillIcon\"></b2c-ui-icon>\r\n        </a>\r\n      </li>\r\n      <li *ngIf=\"_twitter\">\r\n        <a external [link]=\"_twitter\">\r\n          <b2c-ui-icon name=\"iconTwitterFillIcon\"></b2c-ui-icon>\r\n        </a>\r\n      </li>\r\n    </ul>\r\n    <ul class=\"list-inline pb-3\">\r\n      <li>\r\n        <a  external [link]=\"appstore\" *ngIf=\"coerceBoolean(appstore)\">\r\n          <b2c-ui-icon name=\"footerAppstoreIcon\"></b2c-ui-icon>\r\n        </a>\r\n      </li>\r\n      <li>\r\n        <a  external [link]=\"playstore\" *ngIf=\"coerceBoolean(playstore)\">\r\n          <b2c-ui-icon name=\"footerPlaystoreIcon\"></b2c-ui-icon>\r\n        </a>\r\n      </li>\r\n    </ul>\r\n\r\n    <p class=\"b2c-copyright pl-2\">\r\n      <ng-container *ngIf=\"copyrightTemplate\">\r\n        <ng-container *ngTemplateOutlet=\"copyrightTemplate\"></ng-container>\r\n      </ng-container>\r\n    </p>\r\n\r\n  </div>\r\n\r\n</nz-drawer>\r\n\r\n<ng-template #navDetailsTemplate let-title=\"title\" let-fn=\"fn\">\r\n  <div class=\"px-2 py-2 padding\" [ngClass]=\"{'mb-3': !isOthers}\">\r\n    <h6 class=\"font-weight-bold text-base\">\r\n      <i nz-icon nzType=\"arrow-left\" nzTheme=\"outline\" class=\"pointer mr-2\" (click)=\"fn()\"></i>\r\n      <span> {{ title }} </span>\r\n    </h6>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #navTitleTemplate let-title=\"title\">\r\n  <div class=\"nav-title bg-black-3 text-uppercase pt-1 pb-1 font-weight-bold text-xs d-block w-100 pl-3\">\r\n    {{ title }}\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #currentCountryTemplate>\r\n  <div class=\"d-flex align-items-center py-2 pointer\">\r\n    <span class=\"nav-icon mr-3 icon-rounded-circle\">\r\n      <b2c-ui-icon [name]=\"_country?.icon\" class=\"icon-rounded-circle\"></b2c-ui-icon>\r\n    </span>\r\n    <div>\r\n      <span class=\"text-black-6 text-xs\">{{ I18nTransKey?.CURRENT_COUNTRY | b2cI18n }}</span>\r\n      <br>\r\n      <span class=\"font-weight-bold text-sm country-title d-block\">{{ _country?.title }}</span>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [HeaderPositioningService]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { structure: [{
            type: Input
        }], others: [{
            type: Input
        }], onSearch: [{
            type: Output
        }], clicked: [{
            type: Output
        }], showTitle: [{
            type: Input
        }], pageTitle: [{
            type: Input
        }], country: [{
            type: Input
        }], facebook: [{
            type: Input
        }], insta: [{
            type: Input
        }], youtube: [{
            type: Input
        }], tele: [{
            type: Input
        }], twitter: [{
            type: Input
        }], logoLink: [{
            type: Input
        }], copyrightTemplate: [{
            type: Input
        }], appstore: [{
            type: Input
        }], playstore: [{
            type: Input
        }], notificationTemplate: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    B2CMobileHeaderComponent.prototype.structure;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype.others;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype.onSearch;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype.clicked;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype.showTitle;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype.pageTitle;
    /**
     * Set FSM logo Url
     * @type {?}
     */
    B2CMobileHeaderComponent.prototype.logoLink;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype.navDrawer;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype.navContext;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype.navCountry;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype.isOthers;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype._country;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype._countries;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype.I18nTransKey;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype._facebook;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype._insta;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype._youtube;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype._telegram;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype._twitter;
    /**
     * Set copyright template
     * @type {?}
     */
    B2CMobileHeaderComponent.prototype.copyrightTemplate;
    /**
     * Set Appstore Icon Url
     * @type {?}
     */
    B2CMobileHeaderComponent.prototype.appstore;
    /**
     * Set Playstore Icon Url
     * @type {?}
     */
    B2CMobileHeaderComponent.prototype.playstore;
    /**
     * Set notification template
     * @type {?}
     */
    B2CMobileHeaderComponent.prototype.notificationTemplate;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype.setNavContext;
    /** @type {?} */
    B2CMobileHeaderComponent.prototype.toggleNavCountry;
    /**
     * @type {?}
     * @private
     */
    B2CMobileHeaderComponent.prototype.cdRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-s-header.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CSimpleHeaderComponent {
    /**
     * @param {?} hpService
     * @param {?} responsiveService
     * @param {?} cdRef
     */
    constructor(hpService, responsiveService, cdRef) {
        this.hpService = hpService;
        this.responsiveService = responsiveService;
        this.cdRef = cdRef;
        this.fixed = true;
        this.clicked = new EventEmitter();
        this.positionEvent$ = this.hpService.positionObs$;
        this.mobile = false;
        this.responsiveService
            .isMobileWeb()
            .pipe(tap((/**
         * @param {?} mobile
         * @return {?}
         */
        mobile => {
            this.mobile = mobile;
            this.cdRef.markForCheck();
        })))
            .subscribe();
        window.scrollTo({
            top: 0,
            left: 0
        });
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.hpService.findHostWrapper(this.topWrapperId);
        this.hpService.initScroll();
        this.hpService.calculatePusherHeight(this.header, this.pusher);
    }
    /**
     * @return {?}
     */
    emitNavigationEvent() {
        this.clicked.emit();
    }
}
B2CSimpleHeaderComponent.ɵfac = function B2CSimpleHeaderComponent_Factory(t) { return new (t || B2CSimpleHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.HeaderPositioningService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
B2CSimpleHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CSimpleHeaderComponent, selectors: [["b2c-simple-header"]], viewQuery: function B2CSimpleHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, true);
        ɵngcc0.ɵɵviewQuery(_c3, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.header = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.pusher = _t.first);
    } }, inputs: { fixed: "fixed", topWrapperId: "topWrapperId" }, outputs: { clicked: "clicked" }, features: [ɵngcc0.ɵɵProvidersFeature([HeaderPositioningService])], decls: 7, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["staticHeaderTemplate", ""], ["contentTemplate", ""], ["fsmIconTemplate", ""], [4, "ngIf"], [1, "w-100", "d-block", "position-fixed", "bg-white", 3, "ngClass", "ngStyle"], ["header", ""], [4, "ngTemplateOutlet"], [1, "w-100", "d-block", "b2c-simple-pusher"], ["pusher", ""], [1, "w-100", "d-block", "mb-2", 3, "ngClass"], [1, "container", "bg-white", "d-flex", "py-2"], [1, "flex-grow-1", 3, "ngClass"], [1, "pointer", 3, "name", "click"]], template: function B2CSimpleHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, B2CSimpleHeaderComponent_ng_container_0_Template, 3, 3, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, B2CSimpleHeaderComponent_ng_template_1_Template, 2, 2, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, B2CSimpleHeaderComponent_ng_template_3_Template, 3, 4, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, B2CSimpleHeaderComponent_ng_template_5_Template, 1, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.fixed)("ngIfElse", _r1);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgClass, ɵngcc3.NgStyle, ɵngcc3.NgTemplateOutlet, ɵngcc6.B2CUiIconComponent], pipes: [ɵngcc3.AsyncPipe], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CSimpleHeaderComponent.ctorParameters = () => [
    { type: HeaderPositioningService },
    { type: ResponsiveService },
    { type: ChangeDetectorRef }
];
B2CSimpleHeaderComponent.propDecorators = {
    topWrapperId: [{ type: Input }],
    fixed: [{ type: Input }],
    clicked: [{ type: Output }],
    header: [{ type: ViewChild, args: ['header', { static: false },] }],
    pusher: [{ type: ViewChild, args: ['pusher', { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CSimpleHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-simple-header',
                template: "<ng-container *ngIf=\"fixed; else staticHeaderTemplate\">\r\n  <ng-container *ngIf=\"(positionEvent$ | async) as posEvent\">\r\n    <div class=\"w-100 d-block position-fixed bg-white\" [ngClass]=\"mobile ? 'b2c-simple-header-mobile' : 'b2c-simple-header-web'\" [ngStyle]=\"{'top': posEvent?.topHeight + 'px'}\" #header>\r\n      <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\r\n    </div>\r\n    <div class=\"w-100 d-block b2c-simple-pusher\" #pusher></div>\r\n  </ng-container>\r\n</ng-container>\r\n\r\n<ng-template #staticHeaderTemplate>\r\n  <div class=\"w-100 d-block mb-2\" [ngClass]=\"mobile ? 'b2c-simple-header-mobile' : 'b2c-simple-header-web'\">\r\n    <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #contentTemplate>\r\n  <div class=\"container bg-white d-flex py-2\">\r\n    <div class=\"flex-grow-1\" [ngClass]=\"{'text-center': mobile}\">\r\n      <ng-container *ngTemplateOutlet=\"fsmIconTemplate\"></ng-container>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n\r\n<ng-template #fsmIconTemplate>\r\n  <b2c-ui-icon [name]=\"mobile? 'fsmoneMobileLogoIcon' : 'fsmoneLogoIcon'\" class=\"pointer\" (click)=\"emitNavigationEvent()\"></b2c-ui-icon>\r\n</ng-template>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [HeaderPositioningService]
            }]
    }], function () { return [{ type: ɵngcc1.HeaderPositioningService }, { type: ɵngcc1.ResponsiveService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { fixed: [{
            type: Input
        }], clicked: [{
            type: Output
        }], topWrapperId: [{
            type: Input
        }], header: [{
            type: ViewChild,
            args: ['header', { static: false }]
        }], pusher: [{
            type: ViewChild,
            args: ['pusher', { static: false }]
        }] }); })();
if (false) {
    /** @type {?} */
    B2CSimpleHeaderComponent.prototype.topWrapperId;
    /** @type {?} */
    B2CSimpleHeaderComponent.prototype.fixed;
    /** @type {?} */
    B2CSimpleHeaderComponent.prototype.clicked;
    /** @type {?} */
    B2CSimpleHeaderComponent.prototype.header;
    /** @type {?} */
    B2CSimpleHeaderComponent.prototype.pusher;
    /** @type {?} */
    B2CSimpleHeaderComponent.prototype.positionEvent$;
    /** @type {?} */
    B2CSimpleHeaderComponent.prototype.mobile;
    /**
     * @type {?}
     * @private
     */
    B2CSimpleHeaderComponent.prototype.hpService;
    /**
     * @type {?}
     * @private
     */
    B2CSimpleHeaderComponent.prototype.responsiveService;
    /**
     * @type {?}
     * @private
     */
    B2CSimpleHeaderComponent.prototype.cdRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-search-hit.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CSearchHitPipe {
    /**
     * @param {?} searchString
     * @param {?} query
     * @return {?}
     */
    transform(searchString, query) {
        if (!query || (query && query.length === 0)) {
            return searchString;
        }
        return searchString.replace(new RegExp(`(${query})`, 'i'), `<span class='hit'>$1</span>`);
    }
}
B2CSearchHitPipe.ɵfac = function B2CSearchHitPipe_Factory(t) { return new (t || B2CSearchHitPipe)(); };
B2CSearchHitPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "searchHit", type: B2CSearchHitPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CSearchHitPipe, [{
        type: Pipe,
        args: [{ name: 'searchHit' }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-header.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ICONS = [
    FsmoneLogoIcon,
    FsmoneMobileLogoIcon,
    FundTypeIcon,
    AboutTypeIcon,
    EtfsTypeIcon,
    BondsTypeIcon,
    DpmsTypeIcon,
    InsuranceTypeIcon,
    SupportIcon,
    MalaysiaIcon,
    SingaporeIcon,
    HongKongIcon,
    IndiaIcon,
    ResearchArticleIcon,
    FaqIcon,
    StocksTypeIcon,
    FooterLogoIcon,
    FooterAppstoreIcon,
    FooterPlaystoreIcon,
    IconFacebookFillIcon,
    IconInstagramFillIcon,
    IconTelegramFillIcon,
    IconYoutubeFillIcon,
    IconTwitterFillIcon
];
/** @type {?} */
const EXPORTING_COMPONENTS = [
    B2CWebHeaderComponent,
    B2CMobileHeaderComponent,
    B2CHeaderSearchComponent,
    B2CSearchHitPipe,
    B2CSimpleHeaderComponent
];
class B2CHeaderModule {
    /**
     * @param {?} b2cIconService
     */
    constructor(b2cIconService) {
        this.b2cIconService = b2cIconService;
        this.b2cIconService.registerIcons([...ICONS]);
    }
}
B2CHeaderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CHeaderModule });
B2CHeaderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CHeaderModule_Factory(t) { return new (t || B2CHeaderModule)(ɵngcc0.ɵɵinject(ɵngcc6.B2CUiIconService)); }, imports: [[
            CommonModule,
            NzDropDownModule,
            NzGridModule,
            B2CNgzIconModule,
            NzButtonModule,
            B2cUiIconModule,
            B2CSharedPositionModule,
            NzDrawerModule,
            I18nModule,
            NzSelectModule,
            NzInputModule,
            ReactiveFormsModule,
            NzSpinModule,
            B2CSharedResponsiveModule,
            B2CInfiniteScrollModule,
            SharedDirectiveModule,
            B2CMobileSelectModule,
            RouterModule
        ]] });
/** @nocollapse */
B2CHeaderModule.ctorParameters = () => [
    { type: B2CUiIconService }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CHeaderModule, { declarations: function () { return [B2CWebHeaderComponent,
        B2CMobileHeaderComponent,
        B2CHeaderSearchComponent,
        B2CSearchHitPipe,
        B2CSimpleHeaderComponent]; }, imports: function () { return [CommonModule,
        NzDropDownModule,
        NzGridModule,
        B2CNgzIconModule,
        NzButtonModule,
        B2cUiIconModule,
        B2CSharedPositionModule,
        NzDrawerModule,
        I18nModule,
        NzSelectModule,
        NzInputModule,
        ReactiveFormsModule,
        NzSpinModule,
        B2CSharedResponsiveModule,
        B2CInfiniteScrollModule,
        SharedDirectiveModule,
        B2CMobileSelectModule,
        RouterModule]; }, exports: function () { return [B2CWebHeaderComponent,
        B2CMobileHeaderComponent,
        B2CHeaderSearchComponent,
        B2CSearchHitPipe,
        B2CSimpleHeaderComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CHeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [...EXPORTING_COMPONENTS],
                exports: [...EXPORTING_COMPONENTS],
                imports: [
                    CommonModule,
                    NzDropDownModule,
                    NzGridModule,
                    B2CNgzIconModule,
                    NzButtonModule,
                    B2cUiIconModule,
                    B2CSharedPositionModule,
                    NzDrawerModule,
                    I18nModule,
                    NzSelectModule,
                    NzInputModule,
                    ReactiveFormsModule,
                    NzSpinModule,
                    B2CSharedResponsiveModule,
                    B2CInfiniteScrollModule,
                    SharedDirectiveModule,
                    B2CMobileSelectModule,
                    RouterModule
                ]
            }]
    }], function () { return [{ type: ɵngcc6.B2CUiIconService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CHeaderModule.prototype.b2cIconService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-header.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function B2CHeaderMetaModel() { }
if (false) {
    /** @type {?} */
    B2CHeaderMetaModel.prototype.title;
    /** @type {?|undefined} */
    B2CHeaderMetaModel.prototype.url;
    /** @type {?|undefined} */
    B2CHeaderMetaModel.prototype.clickable;
    /** @type {?|undefined} */
    B2CHeaderMetaModel.prototype.icon;
    /** @type {?|undefined} */
    B2CHeaderMetaModel.prototype.children;
    /** @type {?|undefined} */
    B2CHeaderMetaModel.prototype.runOutsideAngular;
}
/**
 * @record
 */
function B2CHeaderCountryMetaModel() { }
if (false) {
    /** @type {?|undefined} */
    B2CHeaderCountryMetaModel.prototype.external;
}
/**
 * @record
 */
function B2CProductCataloqueModel() { }
if (false) {
    /** @type {?} */
    B2CProductCataloqueModel.prototype.label;
    /** @type {?} */
    B2CProductCataloqueModel.prototype.value;
    /** @type {?} */
    B2CProductCataloqueModel.prototype.icon;
}
/**
 * @record
 */
function B2CProductSearchResultModel() { }
if (false) {
    /** @type {?} */
    B2CProductSearchResultModel.prototype.label;
    /** @type {?} */
    B2CProductSearchResultModel.prototype.value;
    /** @type {?|undefined} */
    B2CProductSearchResultModel.prototype.subtitle;
}
/**
 * @record
 */
function B2CProductSearchQueryModel() { }
if (false) {
    /** @type {?} */
    B2CProductSearchQueryModel.prototype.category;
    /** @type {?} */
    B2CProductSearchQueryModel.prototype.query;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-header.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CHeaderModule, B2CMobileHeaderComponent, B2CSimpleHeaderComponent, B2CWebHeaderComponent, OVERLAY_ID, defaultCountries, defaultProductCataloque, B2CHeaderSearchComponent as ɵa, B2CSearchHitPipe as ɵb };


//# sourceMappingURL=b2c-ui-header.js.map